import React, { useEffect, useState, useRef } from 'react';
import * as d3 from 'd3';
import PmModuleStyle from '../styles/pm.module.css';
import ReactDOM from 'react-dom';
import Button from '../../common/Button';
import { useOutletContext} from "react-router-dom";
import { preworkData, graphValues, uiPopupDataObject } from './Prework-data.js'
import { get_prework , UpdateDataPrework , retry_prework } from '../services/api';
import { getSession, setSession } from "../../../App";

const Prework = ({from,data}) => {
     //const [ isOverlay, setIsOverlay, simObj, setSimObj, isLoader, setIsLoader, setError] = useOutletContext();
     const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, calculatorPopup, setCalculatorPopup, kpisPopup, setKpisPopup, relaunchPopup, setRelaunchPopup, expandCalcPopup, setExpandCalcPopup] = useOutletContext();
     const [selectedValues, setSelectedValues] = useState([]);
    const [initialLinks, setInitialLinks] = useState(graphValues);
    const [selectedTask, setSelectedTask] = useState({});
    const [uiDataObject, setUiDataObject] = useState(uiPopupDataObject);
    const [isTaskOptionChanged, setIsTaskOptionChanged] = useState(false);
    const [originalSelectedTask, setOriginalSelectedTask] = useState({});
    const [selectedTaskIndex, setSelectedTaskIndex] = useState(null);
    const [showTaskSelectionPopup, setShowTaskSelectionPopup] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [ispreworkData, setIspreworkData] = useState(preworkData);
    const isSave = useRef(false)
    const [eventType, setEventType] = useState("");
    const [dependentTasks, setDependantTasks] = useState([]);
    const [selectedDependentTask, setSelectedDependentTask] = useState([]);
    const [selectedRadioIndex, setSelectedRadioIndex] = useState(0);
    //const [costInputs, setCostInputs] = useState([]);
    const [costInputs, setCostInputs] = useState(Array(preworkData.length).fill('')); //preworkData.map(item => item.cost)
    const [isCostdaysInputChanged, setIsCostdaysInputChanged] = useState(false); //for API call delay
    const [isHandleselectChanged, setIsHandleselectChanged] = useState(false); //for API call delay
    const [verificationCost, setVerificationCost] = useState(Array(preworkData.length).fill(null));
    //const [dayInputs, setDaysInputs] = useState([]);
    const [dayInputs, setDaysInputs] = useState(Array(preworkData.length).fill(''));
    const [verificationDays, setVerificationDays] = useState(Array(preworkData.length).fill(null));
    const [verificationCritical, setVerificationCritical] = useState(Array(preworkData.length).fill(null));
    const [isSubmittedInputs, setIsSubmittedInputs] = useState(false);
    const [inputs, setInputs] = useState(Array(12).fill('')); // Initialize state for 12 inputs
    const [isSubmitEnabled, setIsSubmitEnabled] = useState(false); // State to track if submit button should be enabled
    const [prework, setPrework] = useState();
    const [copyPrework, setCopyPrework] = useState();
    const [finalSubmit, setFinalSubmit] = useState(false);
    const [copyPreworkData, setCopyPreworkData] = useState(JSON.parse(JSON.stringify(ispreworkData)));
    const [resetSelecteddrop,setResetSelecteddrop]=useState(false);
    const [totalDurations,setTotalduration]=useState(0);
    const preworkLinksRef = useRef(prework?.attemptdata?.links);
    const isSaved = useRef(false);
    const isGraphLoaded = useRef(false);
    const taskOptionsUpdated = useRef(false);
    const checkboxUpdated = useRef(false);
    const checkBoxChanged = useRef(false);
    const submitCompleted = useRef(false);
    const hasSubmitted=useRef(false);
    const selOption=useRef("");
    const [isSubmitted,setIssubmitted]=useState(false);
    const [isStepsContainerOpen, setIsStepsContainerOpen] = useState(true);
    const [isScenarioContainerOpen, setIsScenarioContainerOpen] = useState(true);
    const [isApproachOpen, setIsApproachOpen] = useState(true);
    const [isAonBlockOpen, setIsAonBlockOpen] = useState(true);
    //const navigate = useNavigate();
    // const [checkedStates, setCheckedStates] = useState(prework?.attemptdata?.preworkData ? prework?.attemptdata?.preworkData?.map(task => task.isCritical): ispreworkData?.map(task => task.isCritical))
    const [checkedStates, setCheckedStates] = useState(new Array(12).fill(false))
    const [isfromDropdown,setIsfromDropdown]=useState(true);
    const [correctArrays,setCorrectArrays]=useState(Array(preworkData?.length).fill(null));
    const [isRequestLoading,setIsRequestLoading] = useState(false);
    const [taskspop, setTaskpop] = useState(
        Array(12).fill({
          actualTime: 0,
          earlyStart: 0,
          earlyFinish: 0,
          lateStart: 0,
          lateFinish: 0,
          slackTime: 0
        })
      );
    const isKeyDown = useRef(false);  //checkbox keydown state
    const taskspopRef = useRef(taskspop);  
    const [taskOptiontype, setTaskOptiontype] = useState({"A" : "" , "B" : "" , "C" : "" ,"D" : "","E" : "","F" : "","G" : "","H" : "","I" : "","J" : "","K" : "","L" : ""})
    const CostToCompare = ["7000", "23500", "4900", "6300", "2800", "5950", "250", "7700", "2800", "4200", "4900", "425"];
    const DaysToCompare = ["18", "25", "11", "9", "6", "15", "1", "16", "5", "11", "18", "1"];
    const isToActivateToaster = useRef(false);
    // below all for Accessibility Dynamic reading 
    const [hiddentext,setHiddentext]=useState([]);
    const saveSubcontractorflag =useRef(false);
    const criticalCheckedflag =useRef(false);
    const dropdownflag=useRef(false);
    const currtotalDurations = useRef(0);
    const prevTotalDuration = useRef(0);
    const handleMsg= useRef('');
    const isHidepopup=useRef(false);
    const prependDivRef = useRef('');
    const [selectedValues1, setSelectedValues1] = useState([]);
    const [activeIndex,setActiveIndex] =useState(null)
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const listRef = useRef(null);
  
    // end Accessibility state Dynamic reading
    //const isCriticalToCompare = [true, true, false, false, false, true, true, true, false, false, true, true];
    const TargetTotalCost = 100000;
    const TargetTotalDays = 65;
    //const correctArray = ["A", "B", "F", "G", "H", "K", "L"];
    //const copyPreworkData = JSON.stringify(ispreworkData);
    const allCostsNonEmpty = prework?.attemptdata?.preworkData?.every(item => item.cost !== undefined && item.cost !== null && item.cost !== '');    
    const alldurationsNonEmpty = prework?.attemptdata?.preworkData?.every(item => item.duration !== undefined && item.duration !== null && item.duration !== '');
    const allselectedPredecessorNonEmpty = prework?.attemptdata?.preworkData?.slice(1).map((item) => item.selectedPredecessor).every(item => item.length > 0);
    const IsMacOS =/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    let prependDiv='';
    // const scored = prework?.score;
    // const OutofScore=100;
    // const scorePercentage = Math.round((scored / OutofScore) * 100);
    const handlePopupExitSim = (e) => {
        window.close();
      }
    useEffect(()=>{
        if(hiddentext.length > 1 && isHidepopup.current){
            handleMsg.current ='';
            handleMsg.current=hiddentext.join('; ');  
            let timer=IsMacOS ? 5000 : 400;
            setTimeout(() => {
                window.$("#screen-reader-content").text(`${handleMsg.current}`);
            }, timer);  // Set a small delay to ensure focus event finishes
            isHidepopup.current=false;
            //console.log(handleMsg.current)
        }
    },[hiddentext])

    const saveSubcontractor = ()=> {
        //debugger;
        let task = selectedTask?.pmTaskOptions?.find((option)=> option.optionType == selOption.current)
        // let selectedOptions = copyPrework
        if(prework && task !=undefined && task["cost"] != undefined){
            setPrework((prevValues) => ({
                ...prevValues,
                ['attemptdata']: {
                    ...prevValues?.attemptdata,
                    ['selectedOptions']:{
                        ...prevValues?.attemptdata?.selectedOptions,
                        [selectedTask.taskId] : selOption.current
                    }
                }
            }));
        if(task !=undefined && task["cost"] != undefined){
            let names = [
                "A) Foundation",
                "B) Framing",
                "C) Roofing",
                "D) Windows-Doors",
                "E) Plumbing",
                "F) Electrical Wiring",
                "G) Framing Inspection",
                "H) Masonry/Siding",
                "I) Flooring",
                "J) Drywall",
                "K) Painting",
                "L) Final Inspection"
              ];
            CostValidation(task["cost"], task["table-index"]);
            DaysValidation(task["days"], task["table-index"]);
            setHiddentext([]);
            setHiddentext(prev => [...prev, `Updates on the previous action: in a table Cost:${task["cost"]}; Duration(Days):${task["days"]}; updated for Activity  ${names[task["table-index"]]}`]);
            saveSubcontractorflag.current=true;        
            // setTimeout(() => {
            //     setHiddentext([]);
            // }, 2000);
        }
            // taskOptionsUpdated.current = true;
        }
    }
    // scoring functions start

    class Task {
        constructor(taskId, duration, predecessors) {
          this.taskId = taskId;
          this.duration = duration;
          this.predecessors = predecessors;
          this.earlyStart = 0;
          this.earlyFinish = 0;
          this.lateStart = Infinity;
          this.lateFinish = Infinity;
          this.slack = 0;
          this.successors = [];
        }
      }
      
      function findTask(tasks, taskId) {
        return tasks.find(task => task.taskId === taskId);
      }
      
      function calculateCriticalPaths(preworkData) {
        const tasks = preworkData.map(data => new Task(data.taskId, data.duration, data.selectedPredecessor.map(p => p.split(')')[0])));
        
        // Populate successors
        tasks.forEach(task => {
          task.predecessors.forEach(pred => {
            const predecessor = findTask(tasks, pred);
            if (predecessor) {
              predecessor.successors.push(task.taskId);
            }
          });
        });
      
        // Forward pass to calculate early start and finish times
        tasks.forEach(task => {
          if (task.predecessors.length === 0) {
            task.earlyFinish = task.duration;
          } else {
            task.earlyStart = Math.max(...task.predecessors.map(p => findTask(tasks, p).earlyFinish));
            task.earlyFinish = task.earlyStart + task.duration;
          }
        });
      
        // Backward pass to calculate late start and finish times
        const maxEarlyFinish = Math.max(...tasks.map(task => task.earlyFinish));
        tasks.reverse().forEach(task => {
          if (task.successors.length === 0) {
            task.lateFinish = maxEarlyFinish;
          } else {
            task.lateFinish = Math.min(...task.successors.map(s => findTask(tasks, s).lateStart));
          }
          task.lateStart = task.lateFinish - task.duration;
          task.slack = task.lateStart - task.earlyStart;
        });
      
        // Reverse the tasks back to the original order
        tasks.reverse();
      
        // Identify all critical paths
        const criticalPaths = [];
        function findPaths(taskId, path) {
          const task = findTask(tasks, taskId);
          if (task.slack === 0) {
            path.push(taskId);
            if (task.successors.length === 0) {
              criticalPaths.push(path.join(""));
            } else {
              task.successors.forEach(successorId => findPaths(successorId, path));
            }
            path.pop();
          }
        }
      
        tasks.filter(task => task.predecessors.length === 0).forEach(task => findPaths(task.taskId, []));
        //console.log(criticalPaths);
        return criticalPaths
      }
    //calculateProjectDuration
const calculateProjectDuration = (data, arr) => {
    //debugger;
    let totalDuration;
    let criticalArr = arr?.split("");
    if(criticalArr?.length > 1){
        // Filter the data array to get objects with taskid in criticalArr
        const criticalTasks = data.filter(task => criticalArr.includes(task.taskId));
    
        // Map the criticalTasks to get an array of durations
        const durations = criticalTasks.map(task => (task.duration === "") ? 0 : task.duration);
    
        // Sum up the durations
        totalDuration = durations.reduce((acc, duration) => acc + duration, 0);
        //console.log(criticalArr);
    }else{
        totalDuration=0;  
        //console.log(criticalArr);
    }

    // console.log(data);
    // console.log('Critical Tasks:', criticalTasks);
     //console.log('Total Duration:', totalDuration);

    return totalDuration;
}
useEffect(()=>{
    //debugger;
   if(!Array.isArray(prework?.attemptdata) && prework?.attemptdata !== undefined){
       let pwkData=prework?.attemptdata?.preworkData;
       let criticalPath= calculateCriticalPaths(JSON.parse(JSON.stringify(prework?.attemptdata?.preworkData)))[0];
       let collectionDuration =calculateProjectDuration(pwkData,criticalPath);
       if(dropdownflag.current){
        let Msg =`Project Duration: ${collectionDuration} (Days);`;
        let timer= IsMacOS ? 2000 : 400;
           dropdownflag.current=false;
           setTimeout(() => {
            window.$("#screen-reader-content").text(prependDivRef.current + Msg);
        }, timer);  // Set a small delay to ensure focus event finishes
       }
       currtotalDurations.current=collectionDuration; //added for reading duration msg
       setTotalduration(collectionDuration)
       //console.log(criticalPath);
   }
},[prework?.attemptdata])
    const calculateScore = (preworkData) => {
        let score = 0;
        const correctDependencies = {
            "A": [],
            "B": ["A"],
            "C": ["B"],
            "D": ["B"],
            "E": ["B"],
            "F": ["B"],
            "G": ["C", "D", "E", "F"],
            "H": ["G"],
            "I": ["G"],
            "J": ["G"],
            "K": ["H", "I", "J"],
            "L": ["K"]
        };


        // Did they complete all parts of the Activity? = 16% 
        let predecessorsSelLength = preworkData?.filter((supplier)=>supplier.selectedPredecessor.length != 0)?.length;
        let costSelLength = preworkData?.filter((supplier)=>supplier.cost != "")?.length;
        let duarationSelLength = preworkData?.filter((supplier)=>supplier.duration != "")?.length;
        if((predecessorsSelLength == 11) && (costSelLength == 12) && (duarationSelLength == 12)){
            score += 16;
        }

        // Did they set up the precedence correctly? (12 items) = 24%, 2% each item  
        const pointsPerItem = 2;
        preworkData.forEach(task => {
            const taskId = task.taskId;
            const selectedPredecessorIds = task.selectedPredecessor.map(p => p.split(') ')[0]);
        
            if (JSON.stringify(selectedPredecessorIds.sort()) === JSON.stringify(correctDependencies[taskId].sort())) {
                score += pointsPerItem;
            }
        });

        // Did they correctly identify the critical path? = 20% (full credit if correct based on their AON diagram, even if their precedence is incorrect) 
        const criticalPaths = calculateCriticalPaths(preworkData);
        const userCriticalPath = preworkData?.filter((item)=>item.isCritical).map((item)=>item.taskId).join("")
        if(criticalPaths.includes(userCriticalPath) && allselectedPredecessorNonEmpty && allCostsNonEmpty && alldurationsNonEmpty){
            score += 20;
        }
        if((costSelLength == 12) && (duarationSelLength == 12)){
            // Did they meet the duration objective? = 20% (2% off for each day over) 
            const totalDuration = totalDurations
            const totalDurationObjective = 65;

            const durationGap = totalDuration - totalDurationObjective;
            if(durationGap <= 0){
                score += 20;
            }
            else if(durationGap <= 10){
                score += 20- (durationGap * 2);
            }
            // Did they meet the cost objective? = 20% (1% off for each $1,000 over) 
            const totalCost = preworkData.reduce((acc, task) => acc + task.cost,0)
            const totalCostObjective = 100000;
            const costGap = totalCost - totalCostObjective;
            if(costGap <= 0){
                score += 20;
            }
            else if(costGap <= 20000){
                score += (20-parseInt(costGap/1000));
            }
        }
        

        

        return score;
    }
    
    //scoring functions end

    const setValues  = () => {
        const criticalPath= calculateCriticalPaths(JSON.parse(JSON.stringify(prework?.attemptdata?.preworkData)));
        //console.log(criticalPath)
        //debugger;
        if(prework != undefined){
            const criticalStr = prework?.attemptdata?.preworkData?.map((value, index) => value.isCritical ? value.taskId : '').join("");
            if(criticalPath.includes(criticalStr) && allselectedPredecessorNonEmpty && allCostsNonEmpty && alldurationsNonEmpty){
                for(let i=0;i<criticalPath.length;i++){
                if(criticalPath[i] == criticalStr){
                    let isCriticalToCompare= criticalPath[i]?.split("");
                    const newResultsCritical = prework?.attemptdata?.preworkData?.map((value, index) => (isCriticalToCompare?.includes(value.taskId) && value.isCritical) ? true : false)
                    setVerificationCritical(newResultsCritical);
                    setCorrectArrays(isCriticalToCompare)
                }
            }
            }else{
                const newResultsCritical = prework?.attemptdata?.preworkData?.map((value, index) => value.isCritical ? false : false)
                setVerificationCritical(newResultsCritical);
            }
        }
        
        const newResultsCost = costInputs.length > 0 && costInputs.map((value, index) => String(value) === CostToCompare[index]);
        setVerificationCost(newResultsCost);
        const newResultsDays = dayInputs.length > 0 && dayInputs.map((value, index) => String(value) === DaysToCompare[index]);
        setVerificationDays(newResultsDays);
        //const newResultsCritical = ispreworkData.map((value, index) => (isCriticalToCompare?.includes(value.taskId) && value.isCritical) ? true : false)
        //setVerificationCritical(newResultsCritical);
        const subContractorElement = document.querySelector('.sub_contractors');
        if (subContractorElement !== null) { //for disabled node popup
            subContractorElement.classList.add('disabled');
            subContractorElement.style.opacity = "1";
        }
        //console.log(`isCriticalToCompare`,isCriticalToCompare);
        setIsSubmittedInputs(true)
    }
    const verifyInputs = () => {
        window.$("#pmPreworkTable").attr("aria-hidden","true");
        setValues();
        setIsSubmitEnabled(true);
        // if (isSubmitEnabled) {
            setFinalSubmit(true)
        // }
        setIssubmitted(true) //score board
        const subContractorElement = document.querySelector('.sub_contractors');
        if (subContractorElement !== null) { //for disabled node popup
            subContractorElement.classList.add('disabled');
            subContractorElement.style.opacity = "1";
        }
        hasSubmitted.current=true;

        setTimeout(() => {
            window.$("#preworkScoreBlock").attr("tabindex","-1").focus();
            window.$("#pmPreworkTable").removeAttr("aria-hidden");
        }, 100);
    };

    useEffect(()=>{
        if(finalSubmit && prework != null && hasSubmitted.current){
            let isCompleted=1;
            const updatedPrework = { ...prework, ["completed"]: isCompleted, ["score"] : calculateScore(JSON.parse(JSON.stringify(prework?.attemptdata?.preworkData)))};
            setPrework(updatedPrework);
            setActiveIndex(null)
            hasSubmitted.current=false;
        }
    },[prework,hasSubmitted.current,finalSubmit])

    useEffect(()=>{
        if(finalSubmit && prework?.completed != 0){
            setFinalSubmit(false);
            handleAttemptData();
        }
    },[finalSubmit,prework?.completed])
    useEffect(()=>{
        if(prework?.completed !== 0 && prework?.status === "COMPLETED"){
            setValues();
            setIssubmitted(true)
            //disabled search box when submitted
            const inputElements = document.querySelectorAll('input.search[autocomplete="off"][tabindex="0"]');
            if(inputElements != null){
                inputElements.forEach(input => {
                    input.disabled = true;
                });
            }
        }else{
            //disabled search box when not submitted
            const inputElements = document.querySelectorAll('input.search[autocomplete="off"][tabindex="0"]');
            if(inputElements != null){
                inputElements.forEach(input => {
                    input.disabled = false;
                });
            }
        }
    },[prework])

    const selectedData = [];
    const taskOptionType = {
        SUB_CONTRACTOR: "Subcontractor",
        SUPPLIER: "Supplier"
    }
    const handleChange = (e, index) => {
        const selectedIndex = e.target.selectedIndex;
        const selectedOption = e.target.options[selectedIndex];
        const selectedValue = selectedOption.value;
        // Check if the selected value already exists in selectedData
        const existingIndex = selectedData.findIndex(item => item.selectedValue === selectedValue && item.index === index);

        // If not found, add it to selectedData
        if (existingIndex === -1) {
            selectedData.push({ selectedValue, index });
        }

        //console.log(selectedData);
    };
    // Define an array to hold activities for each index
    const activitiesByIndex = preworkData.map(() => []);

    // Populate the array with activities
    preworkData.forEach((item, index) => {
        activitiesByIndex[index] = preworkData.map(item => `${item.taskId} - ${item.activity}`);
    });

    const handleSelect = (addedText, $addedChoice) => {
        if(isGraphLoaded.current){
            return
        }
        let selectedNode = addedText.substring(0, 1); // from dropdown
        let closestTr = $addedChoice?.closest('td'); // Get the closest td element
        
        // Ensure you navigate to the parent tr and wrap it in jQuery
        let closestRow = window.$(closestTr?.closest('tr')); // Wrap in $ to create a jQuery object
     
        // Find the button within the closest td and retrieve the data-task value
        let dataTaskValue = closestRow?.find('button[data-task]')?.attr('data-task');
        
        window.$("#screen-reader-content").text('');
        prependDivRef.current=`Updates on the previous action: in Aon diagram ${dataTaskValue} node link to ${selectedNode} node;`;
        const link = {
            "u": selectedNode,
            "v": dataTaskValue,
            "value": {
                "label": ""
            }
        };

        const updatedLinks = preworkLinksRef.current ? [...preworkLinksRef.current, link] : [link];
        setInitialLinks((prevState) => ({
            ...prevState,
            graphdata: {
                ...prevState.graphdata,
                links: updatedLinks,
            },
        }));

        const updatedData = ispreworkData?.map(currtaskId => {
            if (currtaskId.taskId === dataTaskValue) {
                // Combine and filter out duplicates
                const uniquePredecessors = [...new Set([...currtaskId.selectedPredecessor, ...selectedNode])];
        
                return {
                    ...currtaskId,
                    selectedPredecessor: uniquePredecessors
                };
            }
            return currtaskId;
        });

        setIspreworkData(updatedData);
        setInitialLinks((prevState) => ({
            ...prevState,
            graphdata: {
                ...prevState.graphdata,
                preworkData: updatedData,
            },
        }));
        //console.log(selectedNode, 'Item added into:', dataTaskValue);
        setIsHandleselectChanged(true)
        initiateGraph();
        dropdownflag.current=true;
        // Clear the text after 2 seconds (2000 milliseconds)
        // setTimeout(() => {
        //     window.$("#handleMsg3").text('');
        // }, 2000);
    }
    const handleRemove = (removedText, $removedChoice) => { //removedValue, removedText, $removedChoice
        let selectedNode = removedText.substring(0, 1); // from dropdown
        let closestTr = $removedChoice.closest('td'); // Get the closest td element
        
        // Ensure you navigate to the parent tr and wrap it in jQuery
        let closestRow = window.$(closestTr.closest('tr')); // Wrap in $ to create a jQuery object
     
        // Find the button within the closest td and retrieve the data-task value
        let dataTaskValue = closestRow.find('button[data-task]').attr('data-task');
        window.$("#screen-reader-content").text('');
        prependDivRef.current=`Updates on the previous action: in Aon diagram ${dataTaskValue} node link removed from ${selectedNode} node; `;
        setInitialLinks((prevValues) => {
            const newLinks = (preworkLinksRef.current || []).filter(
                (link) => !(link.u === selectedNode && link.v === dataTaskValue)
            );
            
            return {
                ...prevValues,
                graphdata: {
                    ...prevValues.graphdata,
                    links: newLinks,
                },
            };
        });

        const updatedData = ispreworkData.map(currtaskId => {
            if (currtaskId.taskId === dataTaskValue) {
                const updatedSelectedPredecessor = currtaskId.selectedPredecessor.filter(item => item.substring(0,1) !== selectedNode);
                return {
                    ...currtaskId,
                    selectedPredecessor: updatedSelectedPredecessor
                };
            }
            return currtaskId;
        });

        setIspreworkData(updatedData);
        setInitialLinks((prevState) => ({
            ...prevState,
            graphdata: {
                ...prevState.graphdata,
                preworkData: updatedData,
            },
        }));
        initiateGraph();
        setIsHandleselectChanged(true)
        dropdownflag.current=true;
        // Clear the text after 2 seconds (2000 milliseconds)
        // setTimeout(() => {
        //     window.$("#handleMsg3").text('');
        // }, 2000);
    }
        // Function to convert selectedPredecessor to formatted string
        const updatePredecessors = (data) => {
            data.forEach(task => {
                if (task.selectedPredecessor.length > 0) {
                    task.selectedPredecessor = task.selectedPredecessor.map(pred => {
                        const matchingPrevTask = task.prevTaskId.find(prev => prev.previousTaskId.startsWith(pred));
                        return matchingPrevTask ? matchingPrevTask.previousTaskId : pred;
                    });
                }
            });
        }
        const handleAttemptData = () => {
            if (resetSelecteddrop){
                setResetSelecteddrop(false);
                return
            }
            if(!isRequestLoading){
                setIsRequestLoading(true);
            setTimeout(() => {
                if (prework != {}) {
                    UpdateDataPrework(prework).then((response) => {
                        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                            setError(response?.data)
                        }
                        else {
                            if (typeof response != 'undefined') {
                                if(isToActivateToaster.current){
                                    isToActivateToaster.current = false;
                                    setActiveIndex(null)
                                    window.$('#saveToaster').show().transition('fade in');
                                      document.querySelector("#saveToaster").setAttribute("aria-hidden","false");
                  
                                      // Hide the message after 3 seconds
                                      setTimeout(function() {
                                        window.$('#saveToaster').transition('fade out').hide();
                                        document.querySelector("#saveToaster").setAttribute("aria-hidden","true")
                                      }, 3000);
                                }
                                setPrework(response?.data);
                                setCopyPrework(response?.data);
                                setIsLoader(false)
                                setIsRequestLoading(false);
                                //setIsSubmitEnabled(false);
                            }
                        }
                    }).catch((error) => {
                        // setError("Only instructor can change settings.");
                        //setError({"id":"00000","msg":"Only instructor can change settings."})
                        console.log(error);
                    })
                }
                 //console.log("PUT call Success...");
            }, 100)
        }
    }
//Retry API call
    const retryPrework = (e) => {
        setTimeout(() => {
            if (prework != {}) {
                retry_prework(prework.sessionid).then((response) => {
                    if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                        setError(response?.data)
                    }
                    else {
                        if (typeof response != 'undefined' ) {
                            setPrework(response?.data);
                            if(response.status === 200){
                                get_preworkData();
                            }
                            setIsLoader(false)
                            setIsSubmitEnabled(false);
                            setIssubmitted(false); //for score box
                            window.$(".firstHeading").attr("tabindex", "-1").focus();
                            window.$("html, body").animate(
                                {
                                  scrollTop: 0,
                                },
                                100
                              );
                            //Dynamic reading states
                              setHiddentext([]);
                              saveSubcontractorflag.current=false;
                              criticalCheckedflag.current=false;
                              dropdownflag.current=false;
                              currtotalDurations.current=0;
                              prevTotalDuration.current=0;
                              handleMsg.current='';
                              isHidepopup.current=false;
                              prependDivRef.current='';
                              setActiveIndex(null)
                            //end Dynamic reading states  
                        }
                    }
                }).catch((error) => {
                    // setError("Only instructor can change settings.");
                    //setError({"id":"00000","msg":"Only instructor can change settings."})
                    console.log(error);
                })
            }
        }, 100)

        setIspreworkData(copyPreworkData);
        setResetSelecteddrop(true);
        setIsSubmittedInputs(false)
        //navigate(rootRoute + "/pm");
    }
    const CostValidation = (tdCostvalue, index) => {
        const newInputs = [...costInputs];
        newInputs[index] = tdCostvalue;
        setCostInputs(newInputs);
        //Tracking cost ispreworkData state
        //const updatedData = prework?.attemptdata?.preworkData != undefined ? [...prework?.attemptdata?.preworkData] : [...ispreworkData];
        const updatedData = [...ispreworkData]
        if (updatedData && Array.isArray(updatedData) && index >= 0 && index < updatedData.length) {
            updatedData[index].cost = parseInt(tdCostvalue);
            setIspreworkData(updatedData);   
        }
        
    }


    // Function to calculate sum
    const calculateTotalCost = () => {
        let currTotalCost = 0;
        costInputs.forEach(inputVal => {
            currTotalCost += parseFloat(inputVal) || 0;
        });
        return currTotalCost;
    };
    useEffect(()=>{
        let currTotalCost = 0;
        costInputs.forEach(inputVal => {
            currTotalCost += parseFloat(inputVal) || 0;
        });
        if(saveSubcontractorflag.current && currTotalCost != 0 && !hiddentext.includes(`Total Cost : $${currTotalCost};`)){
            setHiddentext(prev => [...prev, `Total Cost : $${currTotalCost};`]); 
            if(currtotalDurations.current != 0 && currtotalDurations.current !== prevTotalDuration.current && !hiddentext.includes(`Project Duration : ${currtotalDurations.current}(Days);`)){
                setHiddentext(prev => [...prev, `Project Duration : ${currtotalDurations.current}(Days);`]);
                prevTotalDuration.current = currtotalDurations.current;
            }
            saveSubcontractorflag.current=false;
        }
    },[costInputs])

    const DaysValidation = (tdDayvalue, index) => {
        const intValue = parseInt(tdDayvalue);
        const newInputs = [...dayInputs];
        newInputs[index] = tdDayvalue;
        setDaysInputs(newInputs);
        //Tracking duration/Days ispreworkData state
        //const updatedData =  prework?.attemptdata?.preworkData != undefined ? [...prework?.attemptdata?.preworkData] : [...ispreworkData];
        const updatedData = [...ispreworkData]
        if (updatedData && Array.isArray(updatedData) && index >= 0 && index < updatedData.length) {
        updatedData[index].duration = parseInt(tdDayvalue);
        setIspreworkData(updatedData);
        }
    }
    // Function to calculate sum
    const calculateTotalDays = () => {
        let currTotalDay = 0;
        dayInputs.forEach(inputVal => {
            currTotalDay += parseFloat(inputVal) || 0;
        });
        return currTotalDay;
    };
    const checkBoxHandler = (index, e) => {
        //debugger;
        const isChecked = e.target.checked;
        setIsChecked(isChecked);
        // Update checkedStates
        const newCheckedStates = checkedStates.map((state, i) => (i === index ? isChecked : state));
        setCheckedStates(newCheckedStates);

        const ActualData =  prework?.attemptdata?.preworkData != undefined ? [...prework?.attemptdata?.preworkData] : [...ispreworkData];
        // Update ispreworkData
        const updatedPreworkData = ActualData.map((task, i) => 
            i === index ? { ...task, isCritical: isChecked } : task
        );
        setIspreworkData(updatedPreworkData);
        criticalCheckedflag.current = true; 
        checkBoxChanged.current = true;
    }
    const handleKeyDownCheckBox = (index, e) => {
        if (e.key === ' ' || e.key === 'Enter') {
            if (isKeyDown.current) {
                // Prevent action if key is already being held down
                return;
            }
            isKeyDown.current = true;
            e.preventDefault();
            const currentCheckbox = document.getElementById(`checkbox-${index}`);
            currentCheckbox.click();
        }
    };
    const getCriticalTaskIds = (ActualData) => {
        const criticalTaskIds = ActualData.filter(task => task.isCritical === true).map(task => task.taskId);
        return criticalTaskIds;
    };
    const compareArrays = (array1, array2) => {
        if (array1?.length !== array2?.length) {
            return false;
        }
        return array1.every((element, index) => element === array2[index]);
    };
    const ActualData =  prework?.attemptdata?.preworkData != undefined ? [...prework?.attemptdata?.preworkData] : [...ispreworkData];
    const arraysAreEqual = compareArrays(getCriticalTaskIds(ActualData), correctArrays);
    // Function to check if all inputs are filled for submit
    const areAllInputsFilled = (inputs) => {
        return inputs.every(input => input !== '' && input !== null && input !== undefined);
    };
    //API Intigration
    const get_preworkData = (e) => {
        get_prework().then((response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                setError(response?.data)
            }
            else {
                if (typeof response != 'undefined') {
                    setPrework(response?.data);
                    setCopyPrework(response?.data)
                    setIsLoader(false)
                }
            }
        }).catch((error) => {
            // setError("Only instructor can change settings.");
            //setError({"id":"00000","msg":"Only instructor can change settings."})
            console.log(error);
        })
    }

    const handleTaskSelect = (position, task) => {
        setIsTaskOptionChanged(false);
        //    setToggleSimulation(false);
        setShowTaskSelectionPopup(true);
        // window.$(".aon_instructions,.header-container,#parameter-div,#visual-container,#graph_tooltip").attr({"aria-hidden":"true"});
        // if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
        //     window.$(".task-selector").find(".person-description").removeAttr("aria-hidden tabindex");
        // }
        let taskIndex = getAlphabetIndex(task);
        selectTask(taskIndex);
        window.$('.ui.modal')
            .modal({
                onApprove: function (event) {
                    alert("approve");
                },
                onVisible : ()=>{
                    // if(!taskOptionsUpdated.current){
                        // setTimeout(() => {
                            // setCopyPrework(prework);
                        // }, 100);
                        // selOption.current = ""
                    // }
                }
            })
        window.$(".task-selector-bg.modal").length > 1 && window.$(".task-selector-bg.modal:first-child").remove()
        // window.$(".task-selector-bg.modal").html("");
        let $previouslyFocusedElement; // Variable to store the previously focused element
        window.$(".task-selector-bg.modal").modal({
            onShow: function(){
                // Store the currently focused element
                $previouslyFocusedElement = window.$(document.activeElement);
                window.$("#root").find("*").not("#screen-reader-content").not("[disabled=disabled]").not("[aria-hidden=true]").not("[tabindex=-1]").attr({"kn":'kn', "aria-hidden":true,'tabindex':'-1','disabled':'disabled'});
                 // Focus on the modal or the first focusable element inside the modal
                const $modal = window.$(".task-selector-bg.modal");
                const $firstFocusableElement = $modal.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').first();

                if ($firstFocusableElement.length) {
                    $firstFocusableElement.focus();
                } else {
                    // If no focusable element is found, focus on the modal itself
                    $modal.focus();
                }
            },
            onHide: function(){
                window.$("#root").find("*[kn]").removeAttr("kn aria-hidden tabindex disabled");

        // Return focus to the previously focused element
                if ($previouslyFocusedElement && $previouslyFocusedElement.length) {
                    $previouslyFocusedElement.focus();
                }
                isHidepopup.current=true;
            }
        })
        window.$(".task-selector-bg.modal").attr("task", task).modal("show");
        //setToggleSimulation(false);
        //window.$(".save_tasks").addClass("disabled").attr("disabled",'disabled');
    }
    const selectTask = (taskIndex) => {
        setSelectedTaskIndex(taskIndex);
        //console.log(uiDataObject)
        setOriginalSelectedTask(JSON.parse(JSON.stringify(uiDataObject.decisionActions[taskIndex])));
        setSelectedTask(uiDataObject.decisionActions[taskIndex])
        // let selectedTask = Object.keys(selectedTask).length == 0 && uiDataObject?.actions?.projectPlanOptions[taskIndex];
        if (selectedTask?.pmTaskOptions?.length == 3 || uiDataObject.decisionActions[taskIndex]?.pmTaskOptions?.length == 3) {
            setSelectedRadioIndex(1)
        } else {
            setSelectedRadioIndex(0)
        }
        //updateTaskOptions(uiDataObject?.actions?.projectPlanOptions[taskIndex]?.selectedOptionType);
    }
    const onClickHandler = (event) => {
        //setCopyPrework(prework)
        selOption.current = ""
        let currentTarget = event.currentTarget.classList.contains('node') ? event.currentTarget.previousSibling : event.currentTarget;
        let task = currentTarget.textContent;
        let position = currentTarget.getBoundingClientRect();
        let tooltip = document.getElementById('graph_tooltip');
        if (/Android|iPad/i.test(navigator.userAgent)) {
            handleTaskSelect(position, task);
            // if (currentTask && currentTask.task && currentTask.task == task && currentTask.attempt == 1) {
            //     window.$('#graph_tooltip').hide();
            //     handleTaskSelect(position, task);
            //     currentTask.attempt = 0;
            // } else {
            //     showToolTip(position, task);
            //     currentTask.task = task;
            //     currentTask.attempt = 1;
            // }
        } else {
            handleTaskSelect(position, task);
        }
        if (window.$('.save_tasks').length > 0 && event.type != "click") {
            window.$('.taskPopUpHeading').focus();
        }
        //hidePopup();
        // document.getElementById("closePopup").addEventListener("click", function(event) {
        //     event.stopPropagation();
        //     closeTaskSelectionPopup('close');
        // });
        //focusPopUp();
        event.stopPropagation();
    }
    const onHandleChange = (task, name) => {
        setSelectedTask((prevTask) => ({
            ...prevTask,
            ['pmTaskOptions']: [...prevTask?.pmTaskOptions?.map((task) => {
                return (task?.optionType == selectedTask?.selectedOptionType) ? { ...task, [name == 'overtime' ? 'overTimeSelected' : 'localSupplierSelected']: true } : { ...task }
            })]
        }));
    }

    const onHandleSelectTaskOption = (task, index) => {
        // debugger;
        if (resetSelecteddrop){
            setResetSelecteddrop(false);
            return
        }
        // CostValidation(task["cost"], index);
        // DaysValidation(task["days"], index);
        //console.log(task.optionType)
        setSelectedTask((prevTask) => ({
            ...prevTask,
            ['selectedOptionType']: task.optionType
        }))
        //selected options
        const updatedData ={...prework?.attemptdata?.selectedOptions ,[task.taskId]:task.optionType}
        setTaskOptiontype(updatedData)
        let a = selectedDependentTask
        for (const i in a) {
            a[i].selectedOptionType = task.optionType
            a[i]['optionsUpdated'] = true;
            for (const j in a[i].pmTaskOptions) {
                if (a[i].pmTaskOptions[j].optionType == task.optionType) {
                    a[i].pmTaskOptions[j].localSupplierSelected = false
                    a[i].pmTaskOptions[j].overTimeSelected = false
                }
            }
        }
        setSelectedDependentTask(a);
        //updateTaskOptions(task.optionType);
        //calculateProjectParams();
        //onHandleDeselectOther();
        // setIsCostdaysInputChanged(true);
    }

    const closeTaskSelectionPopup = (type) => {
        setIsTaskOptionChanged(false)
        try {
            if (type == "close") {
                isSave.current = false;
                setSelectedTask(JSON.parse(JSON.stringify(originalSelectedTask)))
                /*setUiDataObject((prevDataObj) => ({
                    ...prevDataObj,
                    ['actions']: {
                        ...prevDataObj?.actions,
                        ['projectPlanOptions']: [...prevDataObj?.actions?.projectPlanOptions?.map((pPlanOpt, taskIdx) => (taskIdx == selectedTaskIndex) ? { ...originalSelectedTask } : { ...pPlanOpt })]
                    }
                }))*/
            }
            let allnode = window.$(".textAchor");
            for (let i = 0; i < allnode.length; i++) {
                let innerTextOfNode = allnode[i].getElementsByTagName("text")[0].innerHTML || allnode[i].getElementsByTagName("text")[0].textContent;
                if (innerTextOfNode == originalSelectedTask.taskId) {
                    window.$(allnode[i]).focus();
                    break;
                }
            }
            if (uiDataObject.decisionActions[selectedTaskIndex]) {
                uiDataObject.actions.projectPlanOptions[selectedTaskIndex] = JSON.parse(JSON.stringify(selectedTask));
            }
            //calculateProjectParams();
            setShowTaskSelectionPopup(false)
            window.$(".task-selector-bg.modal").modal("hide");
            setTimeout(() => {
                //focusPopUp()
            }, 1000);
            window.$(".aon_instructions,.header-container,#parameter-div,#visual-container,#graph_tooltip").attr({ "aria-hidden": "false" });
            setEventType("");
        }
        catch (error) {

        }
        finally {
            //calculateProjectParams();
            setShowTaskSelectionPopup(false)
            window.$(".task-selector-bg.modal").modal("hide");
            setTimeout(() => {
                //focusPopUp()
            }, 1000);
            window.$(".aon_instructions,.header-container,#parameter-div,#visual-container,#graph_tooltip").attr({ "aria-hidden": "false" });
            setEventType("");
        }
    }
    useEffect(() => {
        if (showTaskSelectionPopup) {
            document.querySelectorAll("#aon_container a").forEach((item) => {
                //item.setAttribute("tabindex", "-1")
            })
        }
        else {
            document.querySelectorAll("#aon_container a").forEach((item) => {
                //item.removeAttribute("tabindex")
            })
        }
    }, [selectTask, showTaskSelectionPopup])

    useEffect(() => {
        if (showTaskSelectionPopup && eventType != "") {
            document.querySelector(".taskPopUpHeading").focus();
        }
    }, [showTaskSelectionPopup, eventType])
    const preworkStyle = {
        "width": "87.5%",
        "margin": "auto",
        "paddingTop": "15px"
    }
    const formatNum = (num) => {
        return num?.toLocaleString('en-US', { style: 'decimal' });
    }

    useEffect(() => {
        let artifactSel = document.querySelector(".artifacts");
        let OverlaySel = document.querySelector("#overlay");
        let ApprowSel = document.querySelector(".App .row");
        let FooterIntro = document.querySelector('.footer-nav .footer-links .listitem');
        window.$('.ui.accordion').accordion();
        window.$('html, body').animate({
            scrollTop: 0
        }, 100);
        document.title = "Project Management | Prework";
        if (artifactSel !== null) {
            artifactSel.style.display = "none";
        }
        // if (OverlaySel !== null) {
        //     OverlaySel.style.display = "none";
        // }
        setIsOverlay(false);
        if (ApprowSel !== null) {
            ApprowSel.style.minHeight = "auto";
            ApprowSel.style.minHeight = "100vh";
        }
        if (FooterIntro !== null) {
            FooterIntro.style.display = "none"; //for hide intro navigation
        }
        document.querySelector(".title").textContent = "Project Management - Prework";
        let element = document.querySelector('h1.title[aria-hidden="false"][tabindex="-1"]');
        if(element != null){
            element.classList.add('firstHeading');
        }
    }, [])

    useEffect(()=>{
        if(prework?.attemptdata?.preworkData){
            setCheckedStates(prework?.attemptdata?.preworkData?.map(task => task.isCritical))
        }
    },[prework]);

    useEffect(() => { //updating for selectedOption for pop-up
        if(copyPrework){
            // setPrework((prevValues) => ({
            //     ...prevValues,
            //     ['attemptdata']: {
            //         ...prevValues?.attemptdata,
            //         ['selectedOptions']:taskOptiontype
            //     }
            // }));
            // setCopyPrework((prevValues) => ({
            //     ...prevValues,
            //     ['attemptdata']: {
            //         ...prevValues?.attemptdata,
            //         ['selectedOptions']:taskOptiontype
            //     }
            // }));
            if(selOption.current != ""){
                setCopyPrework((prevValues) => ({
                    ...prevValues,
                    ['attemptdata']: {
                        ...prevValues?.attemptdata,
                        ['selectedOptions']:{
                            ...prevValues?.attemptdata?.selectedOptions,
                            [selectedTask.taskId] : selOption.current
                        }
                    }
                }));
            } 
            // taskOptionsUpdated.current = true;
        }
    }, [selOption.current]);


    useEffect(() => { //updating for selectedOption for pop-up
        if(prework && checkBoxChanged.current){
            setPrework((prevValues) => ({
                ...prevValues,
                ['attemptdata']: {
                    ...prevValues?.attemptdata,
                    ['preworkData']:ispreworkData
                }
            }));
            checkboxUpdated.current = true;
            checkBoxChanged.current = false;
        }
        //console.log(checkedStates)
    }, [checkedStates,checkBoxChanged.current]);
    useEffect(()=>{ //updating for cost & days for using popup
        if(prework){
            if(Array.isArray(prework.attemptdata) && prework?.attemptdata?.length == 0){
                setPrework((prevValues) => ({
                    ...prevValues,
                    ['attemptdata']: {
                        "preworkData": prework?.attemptdata?.preworkData != undefined  ? prework?.attemptdata?.preworkData : ispreworkData?.map((pdata)=>({...pdata,'cost':'','selectedPredecessor':[],'duration':'','isCritical':false})),
                        "selectedOptions":copyPrework?.attemptdata?.selectedOptions
                    }
                }));
            }
        }
    },[prework])


    // useEffect(() => {
    //     debugger;
    //     if(prework && !taskOptionsUpdated.current) {
    //         setTaskOptiontype(prework?.attemptdata?.selectedOptions);
    //         taskOptionsUpdated.current = true;
    //     }
    // }, [prework?.attemptdata?.selectedOptions]);
    useEffect(() => {
        preworkLinksRef.current = prework?.attemptdata?.links;
    }, [prework?.attemptdata?.links]);
    useEffect(() => {
        //below two things need to bookmarking
        // console.log(initialLinks?.graphdata)
        //debugger;
         const updatedPrework = { ...prework, attemptdata: {...prework?.attemptdata,...initialLinks?.graphdata}};
         setPrework(updatedPrework)
    }, [initialLinks])
    useEffect(() => {
        const allFilled = areAllInputsFilled(costInputs) && areAllInputsFilled(dayInputs); // for cost and duration
        //setIsSubmitEnabled(allFilled);
        const selectedPredecessor = ispreworkData.slice(1).map((item) => item.selectedPredecessor);
        const allNotEmpty = selectedPredecessor.every(item => item.length > 0); //for predecessor
        if (allNotEmpty && allFilled) {
            //setIsSubmitEnabled(true)
            //setIsSubmitEnabled(allFilled);
        } else {
            //setIsSubmitEnabled(false)
        }
    }, [costInputs, dayInputs, ispreworkData]);
    /*useEffect(() => {
        // Update the graphValues state with the new preworkData
        setInitialLinks((prevValues) => ({
            ...prevValues,
            graphdata: {
                ...prevValues.graphdata,
                preworkData: ispreworkData
            }
        }));
    }, [ispreworkData]);*/

    // useEffect(() => {
    //     let localsid = localStorage.getItem("session_id") != null ? localStorage.getItem("session_id") : "";
    //     let sessionId = (window.location.hash != "") ? 
    //     (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
    //         if (sessionId != "") {
    //             localStorage["session_id"] = sessionId;
    //             get_preworkData();
    //         }
    // }, []);

    useEffect(()=>{
        // debugger;
        if(from && from=="preworkdecisionhistory" && data && !Array.isArray(data)){
            setPrework(data);
          if(document.querySelector(".footer")){
            document.querySelector(".footer").style.display = "block";
          }
          if(document.querySelector(".sv-components-column.sv-components-container-contentBottom")){
            document.querySelector(".sv-components-column.sv-components-container-contentBottom").style.display = "none";
          }
        }
        else{
          let localsid = getSession() != null ? getSession() : "";
              let sessionId = (window.location.hash != "") ? 
              (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
      
              if (sessionId != "") {
                  setSession(sessionId);
                  get_preworkData();
              }
        }
      },[from,data])

    //debugger;
    let svg, nodes2 = [];
    let width = 580, height = 200;
    let X = width / 2, Y = height / 2, radius = 12;
    let getAlphabetIndex = function (txt) {
        return txt.charCodeAt(0) - 65;
    }
    window.graphdata = prework?.attemptdata;
    const getStateByTask = (label) => {

        let state = 'NOT_STARTED';
        if (["G", "L"].indexOf(label) >= 0) {
            state = 'INSPECTION';
        } else {
            uiDataObject?.laststate?.tasks.forEach(function (task, index) {
                if (task.taskId == label) {
                    state = task.currentState;
                }
            });
        }
        return state;
    }

    var startNodeY = 96; //Added for dynamic scroll
    const initiateGraph = () => {
        //debugger;
        let aonSvg = document.getElementById('aonSvg');
        let defs = aonSvg.querySelector('defs');
        let title = aonSvg.querySelector('#svgTitle');
        let desc = aonSvg.querySelector('#svgDesc');
        while (aonSvg.firstChild) {
            aonSvg.removeChild(aonSvg.firstChild);
        }
        defs != null && aonSvg.appendChild(defs);
        title != null && aonSvg.appendChild(title);
        desc != null && aonSvg.appendChild(desc);
        // Step 1: Log prework?.attemptdata?.links
        //console.log('prework?.attemptdata?.links:', prework?.attemptdata?.links);
        let preworkLinks = (prework?.attemptdata?.links != undefined ? prework?.attemptdata?.links : initialLinks.graphdata.links)
        // Step 2: Convert to JSON string and log it
        let stringifiedLinks = JSON.stringify(preworkLinks);
        //console.log('stringified prework?.attemptdata?.links:', stringifiedLinks);

        // Step 3: Parse the JSON string back into an object/array and log it
        let parsedLinks = JSON.parse(stringifiedLinks);
        //console.log('parsedLinks:', parsedLinks);

        // Step 4: Create a new array from the parsed object/array and log it
        nodes2 = Array.from(parsedLinks);
        //console.log('nodes2:', nodes2);
        let id = -1;
        let nodesToPlot = [];
        let leftOverNodes = [];
        let pushedLeftOverNodes = [];
        let nodesPlotted = [];
        let startNode = {};
        startNode.u = '-';
        startNode.v = 'A';
        startNode.x = 20;
        startNode.y = startNodeY;
        startNode.state = getStateByTask(startNode.v);
        nodesToPlot.push(startNode);
        while (true) {
            if (nodesToPlot.length == 0) {
                if (leftOverNodes.length > 0) {
                    leftOverNodes.forEach(function (itemToPush) {
                        nodesToPlot.push(itemToPush);
                        pushedLeftOverNodes.push(itemToPush);
                    });
                    leftOverNodes = [];
                } else {
                    break;
                }
            } else {
                let item = nodesToPlot[nodesToPlot.length - 1];
                let isAlreadyPlotted = false;
                let alreadyPlottedNode;
                nodesPlotted.forEach(function (plottedNode) {
                    if (plottedNode.label == item.v) {
                        alreadyPlottedNode = plottedNode;
                        isAlreadyPlotted = true;
                    }
                });
                if (!isAlreadyPlotted) {
                    let aleadyLeftOver = false;
                    pushedLeftOverNodes.forEach(function (leftNode) {
                        if (item.v == leftNode.v && item.u == leftNode.u)
                            aleadyLeftOver = true;
                    });
                    let preceedingNodes = getPreviousNodes(item.v);
                    if (preceedingNodes.length > 2 && !aleadyLeftOver) {
                        leftOverNodes.push(item);
                        nodesToPlot.pop();
                    } else {
                        if (nodesPlotted) {
                            let previous;
                            nodesPlotted.forEach(function (plottedNode) {
                                if (plottedNode.label == item.u)
                                    previous = plottedNode;
                            });
                            if (previous) {
                                //let isCriticalPath= (scope.previous.label+item.v)      
                                if (item.state == "INSPECTION") {
                                    drawConnector(previous.x, previous.y, item.x, item.y, isCriticalPathNode(previous.label, item.v), getStateByTask(item.u));
                                } else {
                                    drawConnector(previous.x, previous.y, item.x, item.y, isCriticalPathNode(previous.label, item.v), item.state);
                                }

                            }
                        }
                        drawCircle(radius, item.x, item.y, item.state, item.v);
                        nodesPlotted.push({
                            'label': item.v,
                            'x': item.x,
                            'y': item.y
                        });
                        nodesToPlot.pop();
                        let nextNodes = getNextNodes(item);
                        nextNodes.forEach(function (itemToPush) {
                            nodesToPlot.push(itemToPush);
                        });
                    }
                } else {
                    let previous;
                    nodesPlotted.forEach(function (plottedNode) {
                        if (plottedNode.label == item.u)
                            previous = plottedNode;
                    });
                    if (item.state == "INSPECTION") {
                        drawConnector(previous.x, previous.y, alreadyPlottedNode.x, alreadyPlottedNode.y, isCriticalPathNode(previous.label, alreadyPlottedNode.label), getStateByTask(item.u));
                    } else {
                        drawConnector(previous.x, previous.y, alreadyPlottedNode.x, alreadyPlottedNode.y, isCriticalPathNode(previous.label, alreadyPlottedNode.label), getStateByTask(alreadyPlottedNode.label));
                    }
                    nodesToPlot.pop();
                }
            }
        }
        /* code added for dynamic scroll on AON diagram*/ 
        let scrollnode =0;
        let nodes = document.getElementsByClassName("textAchor")
        var mainAonSvg = window.$("#aonSvg").offset().top;
        let mainAonSvgHeight = window.$("#aonSvg")[0]?.getBoundingClientRect().height;
        for(let i=0;i<nodes.length;i++){
            let uniquenodeTop = window.$(nodes[i]).offset().top;
            if(mainAonSvg > uniquenodeTop){
                scrollnode+= 50;
              
            }
        }
        var maxTopEle = 0;
        var mainAonSvgTop =0;
        var isIncrease=false;
        // var mainAonSvg = window.$("#aon_container")[0].getBoundingClientRect().top;
        for(let i=0;i<nodes.length;i++){
            let uniquenodeTop =  window.$(nodes[i]).offset().top + 30;
           // let y=mainAonSvg < 0 ? 0 : mainAonSvg;
            mainAonSvgTop = mainAonSvg + mainAonSvgHeight;

            if(uniquenodeTop > mainAonSvgTop){
                window.$("#aonSvg").attr("height",mainAonSvgHeight + 96)
                isIncrease=true;
              
            }else{
                if(uniquenodeTop > maxTopEle ){
                    maxTopEle = uniquenodeTop;
                   
                }
            } 
        }
        var diff  =  mainAonSvgTop - maxTopEle;
        //debugger;
       var calculateHeight =  mainAonSvgHeight - 96;
        if(diff > 96){
            window.$("#aonSvg").attr("height", calculateHeight < 200 ? 200 : calculateHeight);
        }
        if(scrollnode > 0){
            startNodeY += scrollnode;
            initiateGraph();
        }
        /* end code added for dynamic scroll on AON diagram*/ 
    }

    const createTooltip = (text) => {
        let selectedNode =  taskspopRef.current[getAlphabetIndex(text)];
        let allDurationsShouldnonzero= taskspopRef.current.every(task => task.actualTime !== 0)
        const statusMap = { 'COMPLETED': 'Completed task', 'IN_PROGRESS': 'In progress task', 'NOT_STARTED': 'Not started task' };
        let nodeStatus = statusMap[selectedNode?.currentState] ?? 'Inspection task';
        //alert(alldurationsNonEmpty && allselectedPredecessorNonEmpty)
        let html = "";
        let activityNames= preworkData.map((item)=> item.activity);

        /*
        (allDurationsShouldnonzero && allselectedPredecessorNonEmpty) ?
            html += '<div id="labelDetails" class="label-details">' +
            '<div>' +
            '<span>Early Start <br aria-hidden="true" role="presentation" />' + selectedNode.earlyStart + '</span>' +
            '<span>Duration <br aria-hidden="true" role="presentation"/>' + selectedNode.actualTime + '</span>' +
            '<span>Early Finish <br aria-hidden="true" role="presentation"/>' + selectedNode.earlyFinish + '</span>' +
            '</div>' +
            '<div>' +
            '<span class="screenHidden">' + '</span><span class="task_name">' + text + ": "  + activityNames[getAlphabetIndex(text)] + '</span>' +
            '</div>' +
            '<div>' +
            '<span>Late Start <br aria-hidden="true" role="presentation"/>' + selectedNode.lateStart + '</span>' +
            '<span>Slack <br aria-hidden="true" role="presentation"/>' + selectedNode.slackTime + '</span>' +
            '<span>Late Finish <br aria-hidden="true" role="presentation"/>' + selectedNode.lateFinish + '</span>' +
            '</div>' +
            '<div>' : 
            // html += '<div id="labelDetails" class="label-details incompletetask">' +
            // '<div>' +
            // '<div>' +
            // '<span class="screenHidden">' + '</span><span class="task_name">' + text + ": Please select predecessor and duration for all tasks"  + '</span>' +
            // '</div>' +
            // '<div>' +
            // '<div>'
            html += '<div id="labelDetails" class="label-details" style="height: 112px;">' +
            '<div>' + '<span class="task_name">' + text + ": "  + activityNames[getAlphabetIndex(text)]   + '</span>' +
            '<span class="task_name">' + "Please select the predecessor and duration for each activity."   + '</span>' +
             '</div>' +
            '</div>'*/ 

            let conditionupdatedData = prework?.attemptdata?.preworkData != undefined ? [...prework?.attemptdata?.preworkData] : [...ispreworkData];
            let hovertask= conditionupdatedData.find(task => task.taskId === text);
            
            (hovertask.duration != '') ?
            html += '<div id="labelDetails1" class="label-details">' +
            '<div>' + '</div>' +
            '<div>' +
            '<span class="screenHidden">' + '</span><span class="task_name">' + text + ") "  + activityNames[getAlphabetIndex(text)] + '</span>' +
            '</div>' +
            '<div>' +
            '<span>Duration <br aria-hidden="true" role="presentation"/>' + selectedNode.actualTime + '</span>' +
            '<span>Slack <br aria-hidden="true" role="presentation"/>' + selectedNode.slackTime + '</span>' +
            '</div>' :

            html += '<div id="labelDetails1" class="label-details noduration">' +
            '<div>'  + '<span class="task_name">' + "Please select Subcontractor for"+ `<div> ${text + ") " + activityNames[getAlphabetIndex(text)]}.</div>` +'</span>' +
             '</div>'

             return html;
    }
    const showToolTip = (currentTarget, position, text) => {
        let circleY;
        let polygonY;
        const circleElement = currentTarget.querySelector('circle');
        if (circleElement) {
            // Get the 'cy' attribute value
            circleY = circleElement.getAttribute('cy');
            // Now you have the y-coordinate value
            //console.log('Circle Y-coordinate:', circleY);
        }
        const polygonElement = currentTarget.querySelector('polygon'); // Select the polygon element within the anchor
        if (polygonElement) {
            // Get the 'points' attribute value
            polygonY = polygonElement.getAttribute('points');
        }
        let tooltip = document.getElementById('graph_tooltip');
        if (tooltip) {
            let calcScrollTop=0;
            let calcScrollLeft=0;
            let aon_containerTop = document.getElementById("aon_container").getBoundingClientRect().top;
            let aonSvgTop = document.getElementById("aonSvg").getBoundingClientRect().top;
            let aon_containerLeft = document.getElementById("aon_container").getBoundingClientRect().left;
            let aonSvgLeft = document.getElementById("aonSvg").getBoundingClientRect().left;
            if(aon_containerTop !== aonSvgTop){
                calcScrollTop = aon_containerTop - aonSvgTop;
            }
            if(aon_containerLeft !== aonSvgLeft){
                calcScrollLeft = aon_containerLeft - aonSvgLeft;
            }
            let top = (position.top - document.getElementById("aon_container").getBoundingClientRect().top) - 80;
            let left = (position.left - document.getElementById("aon_container").getBoundingClientRect().left) - 74;
            let bottom = (position.top - document.getElementById("aon_container").getBoundingClientRect().top) + 25
            // let right = left + tooltip.clientWidth
            tooltip.removeAttribute("style")
            tooltip.classList.remove("bottom");
            tooltip.classList.remove("left");
            tooltip.classList.remove("right")
            tooltip.classList.add("top");
            tooltip.classList.add("center");
            tooltip.classList.remove('adjusted');
            if (((left + window.$(tooltip).width()) > document.getElementById("aon_container").clientWidth) || (top + window.$(tooltip).height()) > document.getElementById("aon_container").clientHeight) {
                tooltip.classList.remove("top");
                tooltip.classList.add("left");
                left = left - 106
                top = top + 54
            }
            else if (left < 0) {
                tooltip.classList.remove("top");
                tooltip.classList.add("right");
                if(Number(circleY) === 28 || polygonY === "66,13 81,28 66,43 51,28"){ 
                    top+=24
                    tooltip.classList.add('adjusted');
                }
                left = left + 96
                top = top + 52
            }
            else if (top < 0 && left > 0) {
                tooltip.classList.remove("top");
                tooltip.classList.add("bottom");
                top = bottom
            }

            // tooltip.setAttribute("style","");
            tooltip.style.left = left + calcScrollLeft + "px"; //("left", left);
            tooltip.style.top = top + calcScrollTop + "px";//css("top", top);
            tooltip.innerHTML = createTooltip(text);
            tooltip.style.display = 'block';
        }
    }

    const getPreviousNodes = (currentNode) => {
        let prevNodes = [];
        nodes2.forEach(function (item) {
            if (item.v == currentNode)
                prevNodes.push(item);
        });
        return prevNodes;
    }
    var getPreceedingNodes = (currentNode) => {
        let nextNodes = [];
        nodes2.forEach(function (item) {
            if (item.u == currentNode)
                nextNodes.push(item);
        });
        return nextNodes;
    }
    const drawConnector = (x1, y1, x2, y2, isCritical, state) => {
        //debugger;
        let color = (isCritical) ? '#000000' : '#000000';  //(isCritical) ? '#DB0020' : '#000000'; comment for remove critical red.
        let width = (isCritical) ? 2 : 1;
        if (x2 - x1 > 50) {
            let tempx1 = x1 + radius;
            let tempx2 = x2 - 30;
            drawLine(tempx1, y1, tempx2, y1, color, width, false, state);
            x1 = x2 - (30 + radius);
        }
        if (x2 - radius < x1 + radius) {
            drawLine((x1 + x2) / 2, y1 + radius, (x1 + x2) / 2, y2 - radius, color, width, true, state);
        } else {
            drawLine(x1 + radius, y1, x2 - radius, y2, color, width, true, state);
        }

    }
    const isCriticalPathNode = (prev, current) => {
        let result;
        //console.log(graphValues.graphdata.criticalPaths)
        /*if (initialLinks.graphdata.criticalPaths[0]) { //copyUiDataObject?.laststate?.criticalPath
            let criticalPaths = initialLinks.graphdata.criticalPaths[0].split(',');  //copyUiDataObject?.laststate?.criticalPath
            result = false;
            criticalPaths?.forEach(function (critialPath) {
                let str = prev + current;
                result = result || critialPath.search(str) >= 0;
            });
        }*/
        return result;
    }
    const drawCircle = (radius, centerX, centerY, state, label) => {
        let isUnplanned = false;
        let labelDetail = "";
        let color;
        let shape;
        let textAchor = svg?.append("a")
            .on("mouseover", onMouseHandler)
            .on("mouseout", onMouseOutHandler)
            .on("click", onClickHandler)
            .on("touchstart", onClickHandler)
            .attr("href", "javascript:void(0)")
            .attr("class", "textAchor ui button")
            .attr("data-position", "bottom center")
            .attr('role', 'button');//rk   
        if (label == "A") {
            // let p = document.createElement("p");
            // let ptxt = document.createTextNode("Hello World");
            // p.appendChild(ptxt);
            // textAchor.append(() => p);  // Append the p element

        }
        if (state == "INSPECTION") {
            centerX = centerX - 15;
            centerY = centerY - 15;
            shape = textAchor?.append('polygon') //.on("mouseover", onMouseHandler).on("click", onClickHandler)
                .attr('points', (centerX + 15) + ',' + centerY + ' ' + (centerX + 30) + ',' + (centerY + 15) + ' ' + (centerX + 15) + ',' + (centerY + 30) + ' ' + centerX + ',' + (centerY + 15))
                .attr('stroke', 'black')
                .attr('stroke-width', '1')
                .attr('class', 'node')
                .attr('fill', '#EA7600');
        } else {
            //debugger;
            shape = textAchor?.append('circle') //.on("mouseover", onMouseHandler).on("click", onClickHandler)
                .attr('cx', centerX)
                .attr('cy', centerY)
                .attr('r', radius)
                .attr('class', 'node')
                .attr('fill', '#80ccff');
        }
        // .attr('tabindex',-1)
        //.attr('role','application'); //rk
        let selectedNode = taskspopRef.current[getAlphabetIndex(label)]; //laststate BS
        let labelStartText = "Early Start " + selectedNode?.earlyStart + " Duration " +
            selectedNode?.actualTime + " Early Finish" + selectedNode?.earlyFinish;
        let labelEndText = "Start " + selectedNode?.lateStart + " Slack " + selectedNode?.slackTime +
            " Late Finish" + selectedNode?.lateFinish;
            
        if (state == 'NOT_STARTED') {
            labelDetail = "Not started task " + label;
            shape?.attr('stroke', '#D4EAE4')
                .attr('stroke-width', 1)
                .attr('fill', '#D4EAE4');
        } else if (state == 'IN_PROGRESS') {
            labelDetail = "In progress task " + label;
            let animation = shape.append('animate')
                .attr('attributeType', 'XML')
                .attr('attributeName', 'fill')
                .attr('values', '#12B2A6;#D4EAE4;#12B2A6;#12B2A6')
                .attr('dur', '1.5s')
                .attr('repeatCount', 'indefinite');
        } else {
            if (state == 'COMPLETED') {
                labelDetail = "Completed task " + label;
                color = '#008638';
            }
            else {
                labelDetail = "Inspection task " + label;
                color = '#EA7600';
            }
            shape?.attr('fill', color);

            //getGradient(color, 'white');
        }
        //textAchor.attr('role','link');
        // textAchor.attr('aria-label',labelDetail);
        let currentId = "labelDetail" + selectedNode;
        textAchor?.attr('aria-labelledby', "labelDetails");

        /*Adding unplanned style to all the task nodes which are not planned on when stage=0*/
        if (uiDataObject.currentstep == 1) {
            let item = uiDataObject.decisionActions[getAlphabetIndex(label)];
            if (!item.optionsUpdated && ['C', 'L', 'Z'].indexOf(item.taskId) < 0) {
                isUnplanned = true;
                shape.attr('stroke', '#505759')
                    .attr('stroke-width', 1)
                    .attr('fill', '#FFFFFF');
            }
        }
        shape?.append('text').text(function (d) {
            return label;
        });
        if (state == "INSPECTION") {
            centerX = centerX + 15
            centerY = centerY + 15;
            drawText(label, centerX - .5, centerY + 1.5, state, isUnplanned);
        } else {
            drawText(label, centerX - .5, centerY + 1.5, state, isUnplanned);
        }
        //drawText(label, centerX, centerY, state);

    }
    var getNextNodes = (currentNode) => {
        //debugger;
        let nextNodes = [];
        nextNodes = getPreceedingNodes(currentNode.v);
        let index = 0;
        nextNodes.forEach(function (item) {
            let prevNodes = [];
            prevNodes = getPreviousNodes(item.v);
            let allPreviousPlotted = true;
            let greatestX = currentNode.x;
            let greatestY = currentNode.y;
            let leastY = currentNode.y;
            let node = item;
            node.x = currentNode.x + 46;
            if (prevNodes.length > 2) {
                prevNodes.forEach(function (prevNode) {
                    if (prevNode.u == item.u && prevNode.v == item.v)
                        prevNode.y = currentNode.y;
                    allPreviousPlotted = allPreviousPlotted && (prevNode.x != undefined) && (prevNode.y != undefined);
                    greatestX = prevNode.x && greatestX < prevNode.x ? prevNode.x : greatestX;
                    greatestY = prevNode.y && greatestY < prevNode.y ? prevNode.y : greatestY;
                    leastY = prevNode.y && leastY > prevNode.y ? prevNode.y : leastY;
                });
                if (allPreviousPlotted) {
                    node.x = greatestX;
                    node.y = prevNodes.length <= 2 ? currentNode.y : leastY + (greatestY - leastY - 17) / 2;
                } else
                    node.y = currentNode.y;
            } else {
                node.y = nextNodes.length <= 1 ? currentNode.y : currentNode.y - (17 * nextNodes.length) + (50) * index;
            }
            node.state = getStateByTask(node.v);
            index++;
        });
        return nextNodes;
    }
    const drawLine = (x1, y1, x2, y2, color, width, isArrowHeadRequired, state) => {
        let line = svg?.append('line')
            .attr('x1', x1)
            .attr('y1', y1)
            .attr('x2', x2)
            .attr('y2', y2)
            .attr('stroke', color)
            .attr('stroke-width', width)
            .attr('stroke-dasharray', state != 'COMPLETED' ? `3, 3` : `0, 0`)
            .attr('aria-hidden', true);
        if (isArrowHeadRequired) {
            if (color == "#DB0020") {
                line?.attr('marker-end', 'url(#red_arrow)');
            } else {
                line?.attr('marker-end', 'url(#grey_arrow)');
            }
        }
    }
    const drawText = (label, x, y, state, isUnplanned) => {
        let text = svg?.append('text')
            .attr("x", x)
            .attr("y", y + 2.5)
            .attr('text-anchor', 'middle')
            .text(function (d) {
                return label;
            })
            .attr('class', 'node')
            .on("click", onClickHandler)
            .on("touchstart", onClickHandler)
            .on("mouseover", onMouseHandler)
            .on("mouseout", hidePopup)
            .attr("font-family", "sans-serif")
            .attr("font-weight", "bold")
            .attr("font-size", "12px");
        if (state == 'NOT_STARTED')
            text?.attr("fill", "#005A70");

        else if (state == 'INSPECTION')
            text?.attr("fill", "#003057");

        else
            text?.attr("fill", "#fff");

        if (isUnplanned) {
            text?.attr("fill", "#505759");
        }
    }
    useEffect(() => {
        // debugger
        svg = d3.select('#aonSvg');
        initiateGraph();
        //let firstLeft = window.$('.textAchor').first().offset().left;
        //let lastLeft = window.$('.textAchor').last().offset().left;
        let nodeX = [];
        window.$(".node").each(function(){
            if(window.$(this).attr('x') != undefined){          
             nodeX.push(Number(window.$(this).attr('x')));
          }
        });
        let toalWdth = Math.max(...nodeX) + 50;
        window.$("#aonSvg").attr("width",toalWdth);
        window.$("#aonSvg").css("min-width",toalWdth);
    }, [initialLinks,prework?.attemptdata?.links])
    useEffect(() => {
        setSelectedDependentTask([])
        //setSelectedDependentTaskIndex('');
        //.attr('role', 'img')
        svg = d3.select('#aonSvg').attr('width', width).attr('height', height).attr('aria-labelledby', 'svgTitle svgDesc');
        (uiDataObject?.laststate?.tasks.length > 0) && initiateGraph();
        window.$('.textAchor').not("svg").popup({
            inline: true,
            //hoverable: true,
            hideOnScroll: 'auto',
            addTouchEvents: true,
            popup: '.prework-graph_info.popup',
            boundary: '.canvas_container',
            onShow: (currentNode) => {
                // let tooltip = document.getElementById('graph_tooltip');
                //  console.log(currentNode);
            },
            onUnplaceable: (currentNode) => {
                let position = currentNode.getBoundingClientRect();
                if (!/Android|iPad/i.test(navigator.userAgent)) {
                    showToolTip(currentNode, position, currentNode.textContent);
                }
            }
        });
        window.$(".ui.modal").modal();
        // window.$(".task-selector-bg.modal").length > 1 && window.$(".task-selector-bg.modal:last-child").remove()
    }, [uiDataObject])

    const onMouseOutHandler = (event) => {
        hidePopup();
    }
    const onMouseHandler = (event) => {
        let currentTarget = event.currentTarget.classList.contains('node') ? event.currentTarget.previousSibling : event.currentTarget;
        let position = currentTarget.getBoundingClientRect();
        if (!/Android|iPad/i.test(navigator.userAgent)) {
            showToolTip(currentTarget, position, currentTarget.textContent);
        }
    }
    const hidePopup = () => {
        let tooltip = document.getElementById('graph_tooltip');
        if (tooltip != undefined && tooltip != null) {
            tooltip.style.display = 'none';
        }
    }
    window.$(window).scroll((e) => {
        hidePopup();
    });

    window.$(document).off('click touchstart', '.textAchor').on('click touchstart', '.textAchor', (event) => {
        event.stopPropagation();
        onClickHandler(event);
    });
    window.$(document).off('click touchstart', '.save_tasks').on('click touchstart', '.save_tasks', (event) => {
        event.stopPropagation();
        window.$('.ui.dimmer').trigger('click');
        setIsTaskOptionChanged(false)
        saveSubcontractor();
        closeTaskSelectionPopup('close')
    });
    window.$(document).off('click touchstart', '.person-item').on('click touchstart', '.person-item', (event) => {
        if(!prework?.completed){
            selOption.current = event.currentTarget.getAttribute("data-optionType")
        }
    });
    window.$(document).off('keydown', '.sub_contractors a').on('keydown', '.sub_contractors a', (event) => {
        let key;
        if (window.event) {
            key = window.event.keyCode;
        } else if (event) {
            key = event.keyCode;
        }
        if (key == 13) {
            window.$(event.currentTarget).find(".person-item").trigger('click');
        }               
        //selOption.current = event.currentTarget.firstChild.getAttribute("data-optionType")
    });
    window.$(document).off('click touchstart', '.close-button').on('click touchstart', '.close-button', (event) => {
        event.stopPropagation();
        window.$('.ui.dimmer').trigger('click');
        setIsTaskOptionChanged(false)
        closeTaskSelectionPopup('close');
        setCopyPrework(prework);
    });
    //for contractor selection
    window.$(document).off('click', '.sub_contractors a').on('click', '.sub_contractors a', (event) => {
        event.stopPropagation();
        let task = JSON.parse(event.currentTarget.getAttribute("task"));
        //let isChecked = window.$(".work_overtime").find("input[type=checkbox]:checked").length > 0;
        if (!Object.keys(dependentTasks).includes(task?.taskId)) {
            (!selectedTask?.taskOptionAvailable) && onHandleSelectTaskOption(task, task['table-index']);
        }
        selOption.current = window.$(event.currentTarget).find(".person-item").attr("data-optionType") //Added for keyDown notworking
        //(isChecked) ?  window.$(".save_tasks").removeClass("disabled").removeAttr("disabled",'disabled') :  window.$(".save_tasks").addClass("disabled").attr("disabled",'disabled');
    });
    useEffect(() => {
        if (prework?.attemptdata) {
            if (prework.attemptdata.length === 0) {
              setPrework({
                ...prework,
                attemptdata: [
                  {
                    links: [],
                    preworkData: [ispreworkData]
                  }
                ]
              });
            } else if (prework.attemptdata.length > 0 && !(prework.status === "COMPLETED" || prework.completed)) {
              setPrework({
                ...prework,
                attemptdata: prework.attemptdata.map(item => ({
                  ...item,
                  links: [...item.links], // Preserve existing links or modify as needed
                  preworkData: [...item.preworkData] // Preserve existing preworkData or modify as needed
                }))
              });
            }
          }
    }, [])
    useEffect(()=>{
        if(prework?.attemptdata?.preworkData != undefined){
            let newCostInputData = (prework?.attemptdata?.preworkData != undefined != undefined ? prework?.attemptdata?.preworkData : ispreworkData)?.map((item)=>item.cost); //binding to attempt data
            setCostInputs(newCostInputData);
            let newDayInputData =  (prework?.attemptdata?.preworkData != undefined != undefined ? prework?.attemptdata?.preworkData : ispreworkData)?.map((item)=>item.duration); //binding to attempt data
            setDaysInputs(newDayInputData);

        }
        if(prework?.attemptdata?.preworkData?.length != 0 && prework?.attemptdata?.preworkData != undefined){
            setIspreworkData(prework?.attemptdata?.preworkData);
        }
         //console.log("prework?.attemptdata?.preworkData",prework?.attemptdata?.preworkData)
    },[prework?.attemptdata?.preworkData])

    useEffect(() => {
        if(resetSelecteddrop){
            //debugger;
            setTimeout(() => {
                const subContractorElement = document.querySelector('.sub_contractors');
                if (subContractorElement !== null) { //for disabled node popup
                    subContractorElement.classList.remove('disabled');
                    subContractorElement.style.opacity = "1";
                }
                const inputElements = document.querySelectorAll('input.search[autocomplete="off"][tabindex="0"]'); //disabled search box
                if(inputElements != null){
                    inputElements.forEach(input => {
                        input.disabled = false;
                    });
                }
                window.$("#aonSvg").attr("height", 200)
                setCostInputs(Array(preworkData.length).fill(''));
                setDaysInputs(Array(preworkData.length).fill(''));
                setCorrectArrays(Array(preworkData.length).fill(null));
                setIsHandleselectChanged(false);
                setTaskOptiontype({"A" : "" , "B" : "" , "C" : "" ,"D" : "","E" : "","F" : "","G" : "","H" : "","I" : "","J" : "","K" : "","L" : ""});
                setTaskpop(Array(12).fill({
                    actualTime: 0,
                    earlyStart: 0,
                    earlyFinish: 0,
                    lateStart: 0,
                    lateFinish: 0,
                    slackTime: 0
                  }))
                setInitialLinks((prevState) => ({
                    ...prevState,
                    graphdata: {
                        ...prevState.graphdata,
                        links: [],
                    },
                }));
                setFinalSubmit(false);
                setCopyPreworkData(JSON.parse(JSON.stringify(ispreworkData)))
                isSaved.current = false;
                isGraphLoaded.current = false;
                taskOptionsUpdated.current = false;
                checkboxUpdated.current = false;
                checkBoxChanged.current = false;
                hasSubmitted.current =false;
            }, 100);    
        }    
        // console.log(`setResetSelecteddrop`,resetSelecteddrop)
}, [resetSelecteddrop])
useEffect(()=>{
    if(!prework?.attemptdata){
        const subContractorElement = document.querySelector('.sub_contractors');
        if (subContractorElement !== null) { //for disabled node popup
            subContractorElement.classList.remove('disabled');
            subContractorElement.style.opacity = "1";
        }
        setVerificationCost(Array(preworkData.length).fill(null));
        setVerificationDays(Array(preworkData.length).fill(null));
        setVerificationCritical(Array(preworkData.length).fill(null));
        setIsSubmittedInputs(false)
    }
},[prework?.attemptdata])
    useEffect(()=>{
        //debugger
        if(taskOptionsUpdated.current){ //updating when optionselction call.
            setTimeout(() => {
                //handleAttemptData();
                // setIsCostdaysInputChanged(false);
                taskOptionsUpdated.current = false;
            }, 500);
        }
    },[taskOptionsUpdated.current])
    useEffect(()=>{
        //debugger
        if(checkboxUpdated.current){ //updating when optionselction call.
            setTimeout(() => {
                //handleAttemptData();
                // setIsCostdaysInputChanged(false);
                checkboxUpdated.current = false;
            }, 100);
        }
    },[checkboxUpdated.current])
    useEffect(()=>{
        //debugger;
        if(prework?.attemptdata?.links?.length != 0 && !isSaved.current){
            if(isHandleselectChanged){
                const copyUIObject = {...prework?.attemptdata}
                const updatedPrework = { ...prework, attemptdata: copyUIObject};
                setPrework(updatedPrework)
                isSaved.current=true;
                // console.log("prework?.attemptdata?.links",prework?.attemptdata?.links);
            }
        }
    },[prework?.attemptdata?.links,isSaved.current])

    useEffect(()=>{
        //debugger;
            if(isSaved.current){
                if (resetSelecteddrop){
                    setResetSelecteddrop(false);
                    return
                }
                updatePredecessors(ispreworkData); //function for convert A to 'A) Foundation'
                setTimeout(() => {
                    //handleAttemptData();
                    setIsHandleselectChanged(false);
                    isSaved.current=false;
                    //console.log(`isSavedCall....`)
                }, 100);
            }
    },[isSaved.current,isHandleselectChanged,resetSelecteddrop]);

    useEffect(()=>{
        if(!headerPopup || !isOverlay){
            setTimeout(() => {
                Array.from(document.querySelectorAll(".showBtn")).map((item)=>{
                    item.setAttribute("tabindex","-1")
                })
            }, 1000);
        }
      },[headerPopup,isOverlay])

    /*
    useEffect(() => {
        const handleTaskSelResize = () => {
            const divTaskSelectorElement = document.getElementById('divTaskSelector');
            const AonContainer = document.getElementsByClassName("Aon-Container")[0].style.width
            if (divTaskSelectorElement) {
                if (window.innerWidth <= 360) {
                    divTaskSelectorElement.style.width = '350px';
                    AonContainer.style.width='0px';
                } else {
                    divTaskSelectorElement.style.width = '400px';
                }
            }
        };
        handleTaskSelResize();
        window.addEventListener('resize', handleTaskSelResize);
        return () => {
            window.removeEventListener('resize', handleTaskSelResize);
        };
    }, []);
    */

    const PMConstants = {
        NUMBER_OF_TASK: 12,
        ASCII_CODE_A: 65
      };
    
      function calculateTaskTime(tasks, ev) {
        // Early Start and Early Finish
        for (let i = 0; i < PMConstants.NUMBER_OF_TASK; i++) {
          let pmTask = tasks[i];
          let pmTaskInformation = ev[i];
          if (pmTaskInformation.precedingTasks && pmTaskInformation.precedingTasks.length > 0) {
            let maxEarlyFinish = 0;
    
            for (let precedingTaskId of pmTaskInformation.precedingTasks) {
              let precedingTaskIndex = precedingTaskId.charCodeAt(0) - PMConstants.ASCII_CODE_A;
              let earlyFinish = tasks[precedingTaskIndex].earlyFinish;
    
              if (earlyFinish > maxEarlyFinish) {
                maxEarlyFinish = earlyFinish;
              }
            }
    
            pmTask.earlyStart = maxEarlyFinish;
            pmTask.earlyFinish = pmTask.actualTime + pmTask.earlyStart;
          } else {
            pmTask.earlyStart = 0;
            pmTask.earlyFinish = pmTask.actualTime + pmTask.earlyStart;
          }
        }
    
        // Late Finish and Late Start
        tasks[PMConstants.NUMBER_OF_TASK - 1].lateFinish = tasks[PMConstants.NUMBER_OF_TASK - 1].earlyFinish;
        tasks[PMConstants.NUMBER_OF_TASK - 1].lateStart = tasks[PMConstants.NUMBER_OF_TASK - 1].lateFinish - tasks[PMConstants.NUMBER_OF_TASK - 1].actualTime;
    
        for (let j = PMConstants.NUMBER_OF_TASK - 2; j >= 0; j--) {
          let pmTask = tasks[j];
          let pmTaskInformation = ev[j];
          let minLateStart = Infinity;
    
          // Check the dependent (successor) tasks for the minimum late start time
          for (let k = j + 1; k < PMConstants.NUMBER_OF_TASK; k++) {
            if (ev[k].precedingTasks.includes(String.fromCharCode(PMConstants.ASCII_CODE_A + j))) {
              let successorTask = tasks[k];
              if (successorTask.lateStart < minLateStart) {
                minLateStart = successorTask.lateStart;
              }
            }
          }
    
          if (minLateStart !== Infinity) {
            pmTask.lateFinish = minLateStart;
            pmTask.lateStart = pmTask.lateFinish - pmTask.actualTime;
          } else {
            pmTask.lateFinish = pmTask.earlyFinish;
            pmTask.lateStart = pmTask.earlyStart;
          }
    
          pmTask.slackTime = pmTask.lateStart - pmTask.earlyStart;
        }
      }
    
      const updateActualTimes = (newActualTimes) => {
        setTaskpop(prevTasks =>
          prevTasks.map((task, index) => ({
            ...task,
            actualTime: newActualTimes[index] !== undefined ? newActualTimes[index] : task.actualTime
          }))
        );
      };
    
      useEffect(() => {
        let ev = [];
        if (prework?.attemptdata?.preworkData && prework?.attemptdata?.selectedOptions) {
          const predecessorSelected = prework?.attemptdata?.preworkData?.map((item) => item.selectedPredecessor);
          const evLatters = predecessorSelected.map(subArray => subArray.map(item => item[0]));
          //console.log(evLatters);
          for (let i = 0; i < evLatters.length; i++) {
            ev.push({ 'precedingTasks': evLatters[i] });
          }
          const actualTimeCalculation = prework?.attemptdata?.preworkData.map((item) => item.duration !== '' ? item.duration : 0);
          //console.log(actualTimeCalculation);
          updateActualTimes(actualTimeCalculation);
    
          if (ev.length > 0) {
            setTaskpop(prevTasks => {
              const newTasks = [...prevTasks];
              calculateTaskTime(newTasks, ev);
              return newTasks;
            });
          }
        }
        //console.log(ev);
      }, [prework?.attemptdata?.preworkData, prework?.attemptdata?.selectedOptions]);
    
      useEffect(() => {
        //console.log(`tooltip Data:`,taskspop);
        taskspopRef.current = taskspop
        //console.log(`tooltip CopyData:`, taskspopRef.current)
      }, [taskspop]);

      useEffect(()=>{
        if(criticalCheckedflag.current && ispreworkData != undefined){
            window.$("#screen-reader-content").text('');
            let criticalVal = getCriticalTaskIds(ispreworkData).join(', ');
            if(criticalVal != ""){
                let Msg = `Updates on the previous action: Project Critical Path: ${criticalVal};`;
                let timer= IsMacOS ? 2000 : 400;
                setTimeout(() => {
                    window.$("#screen-reader-content").text(Msg);
                }, timer);
            }
            criticalCheckedflag.current=false;
        }
      },[ispreworkData])
     //Custom Multi-SelectDropdown
      const handleToggle = (index) => {
        // Toggle: if the clicked button is already active, deactivate it (set to null)
       if (activeIndex === index) {
          setActiveIndex(null);
          setFocusedIndex(-1);
        } else {
          setActiveIndex(index);
          setFocusedIndex(0);
        }
      };
      const handleKeyDownBtn = (event, index) => {
        if (event.key === 'Enter') {
            handleToggle(index);
        }
        if(event.key === 'Tab' && event.shiftKey){
            setActiveIndex(null);
        }
      };
     window.$(document).on("click", function(e){
        if(!window.$(e.target).closest('div[data-id="searchbox"]').length > 0){
            setActiveIndex(null); 
        }
     })
      const handleOptionClick = (previousTaskId,item, e) => {
        e.preventDefault();
        const isSelected = item?.selectedPredecessor?.includes(previousTaskId);
        if (isSelected) {
            // Log removing the option
            handleRemove(previousTaskId,e?.target)
        } else {
            // Log adding the option
            handleSelect(previousTaskId,e?.target);
        }
    };
    
      const handleKeyDown = (previousTaskId,item, e) => {
        if(e === undefined){
            return;
        }
        e.stopPropagation();
        e.preventDefault();
        console.log(item.prevTaskId.map((it) => it.previousTaskId))
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          setFocusedIndex((prevIndex) =>
            prevIndex < item.prevTaskId.map((it) => it.previousTaskId).length - 1 ? prevIndex + 1 : 0
          );
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          setFocusedIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : item.prevTaskId.map((it) => it.previousTaskId).length - 1
          );
        } 
        else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          if (focusedIndex !== -1) {
            // handleOptionClick(options[focusedIndex].value);
            handleOptionClick(previousTaskId,item,e);

          }
        } 
        else if (e.key === 'Escape' || e.key === 'Tab') {
           // Find the closest 'td' and focus on the button referenced by BtnRef
            let currIndex = preworkData.findIndex((dataItem) => dataItem.taskId === item.taskId);
            const tdElement = e.currentTarget.closest('td');
            if (tdElement) {
                window.$(tdElement).find("button").focus();
                handleToggle(currIndex);
            }
        }
      };
    
      useEffect(() => {
        if (activeIndex != null && focusedIndex !== -1 && listRef.current) {
          const optionElement = listRef.current.children[focusedIndex];
          if (optionElement) {
            optionElement.focus();
          }
        }
        if(listRef.current){
            let openUL= window.$(listRef.current);
            let openULTop=openUL.offset().top;
            let openHeight=openUL.height();
            let totalTarget = openULTop + openHeight;
            let targetDiv = window.$(".footer").offset().top;
            if(totalTarget > targetDiv){
                openUL.css("bottom","20px");
            }
        }
      }, [focusedIndex,activeIndex]);  
    //end Custom Multi-SelectDropdown
    return (
        <div className="pm-prework prework container" style={preworkStyle}>
            <div className={`mbottom ${PmModuleStyle.introtext} ${PmModuleStyle['mbottom']}`}>
                <div className={`ui accordion ${PmModuleStyle["ui"]} ${PmModuleStyle["accordion"]} ${PmModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isStepsContainerOpen ? "active" : ""} ${PmModuleStyle["title"]}`}
                        onClick={()=>{
                            setIsStepsContainerOpen(prev => !prev)
                        }}>
                           <h2 id="stepsHeading" className={`${PmModuleStyle['intro-heading']}`}>
                                <span>Steps</span>
                                <button className='chevron-btn' aria-expanded={isStepsContainerOpen} aria-labelledby="stepsHeading">
                                    {
                                    isStepsContainerOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                    : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isStepsContainerOpen ? "active" : ""}`}>
                        <ol className={`${PmModuleStyle['custom-list-ol']}`}>
                        <li>Read scenario and approach.</li>
                        <li>Fill out the table to identify the predecessors based on the information in the Approach.</li>
                        <li>
                            <p style={{marginBottom:"10px"}}>Click on the AON node for the activity to select the best contractor.</p>
                        <ol type="a" className={`${PmModuleStyle["pm-ol-list"]}`}>
                            <li>
                                Note that as you choose a contractor the Cost and Duration (Days) columns are automatically filled out. 
                            </li>
                            <li>Remember that the critical path is the longest path through a project from start to end and the shortest possible duration a project can have. Activities on the critical path have no slack time. Once you make a contract choice, hover over the nodes to see the slack time.</li>
                            <li>Based on this, identify the critical path and denote if an activity falls on the critical path by checking the box in the Critical Path column.</li>
                        </ol>
                        </li>
                        <li>The answers to the following questions are automatically updated in the summary of Total Cost, Project Duration, and Critical Path based on your choices. Keep in mind you must stay within the project guidelines in the scenario below, and changes to cost and duration will have an affect on what appears on the Critical Path, so be sure to double-check those before clicking Submit.</li>
                        <li>
                                    <div>
                                    Click the <div style={{'display': 'inline-block'}}><span className={`${PmModuleStyle["custom-button"]} ${PmModuleStyle["save-customBtn"]}`}>Save</span></div> button to keep your progress. Once you’ve finished the assignment, click the <div style={{'display': 'inline-block'}}><span className={`${PmModuleStyle["custom-button"]} ${PmModuleStyle["submit-customBtn"]}`}>Submit</span></div> button to receive your grade and feedback.
                                    </div>
                                </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div className={`mbottom ${PmModuleStyle.introtext} ${PmModuleStyle['mbottom']}`}>
                <div className={`ui accordion ${PmModuleStyle["ui"]} ${PmModuleStyle["accordion"]} ${PmModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isScenarioContainerOpen ? "active" : ""} ${PmModuleStyle["title"]}`}
                        onClick={()=>{
                            setIsScenarioContainerOpen(prev => !prev)
                        }}>
                            <h2 id="scenarioHeading" className={`${PmModuleStyle['intro-heading']}`}>
                                <span>Scenario</span>
                                <button className='chevron-btn' aria-expanded={isScenarioContainerOpen} aria-labelledby="scenarioHeading">
                                    {
                                    isScenarioContainerOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                    : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isScenarioContainerOpen ? "active" : ""}`}>
                        <p className={`${PmModuleStyle["indent-para"]}`}>You are planning a very basic building project. It only includes the essential items required to build a building. Your project plan must complete this building project in less than 65 days and within a budget of $100,000. This planning process will help prepare you for a much longer, more involved and realistic simulation on building a home.</p>
                    </div>
                </div>
            </div>
            <div className={`${PmModuleStyle.introtext} ${PmModuleStyle['mbottom']}`}>
                <div className={`ui accordion ${PmModuleStyle["ui"]} ${PmModuleStyle["accordion"]} ${PmModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isApproachOpen ? "active" : ""} ${PmModuleStyle["title"]}`}
                        onClick={()=>{
                            setIsApproachOpen(prev => !prev)
                        }}>
                            <h2 id="approachHeading" className={`${PmModuleStyle['intro-heading']}`}>
                                <span>Approach</span>
                                <button className='chevron-btn' aria-expanded={isApproachOpen} aria-labelledby="approachHeading">
                                    {
                                    isApproachOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                    : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isApproachOpen ? "active" : ""}`}>
                        <p className={`${PmModuleStyle["indent-para"]}`}>There are 12 activities that need to be performed for the project to be completed. These are the rules to help you identify in which order each task needs to happen:</p>
                        <ul className={`${PmModuleStyle['custom-list-ol']}`}>
                            <li>The Framing (B) cannot start until the Foundation (A) has been poured.</li>
                            <li>Roofing (C), Windows-Doors (D), Plumbing (E) and installation of the Electrical Wiring (F) cannot begin until the Framing (B) has been completed.</li>
                            <li>The Framing Inspection (G) cannot begin until the Roofing (C), Windows-Doors (D), Plumbing (E) and installation of the Electrical Wiring (F) has finished.</li>
                            <li>Masonry/Siding (H), Flooring (I), and Drywall (J) cannot start until the Framing Inspection (G) is finished.</li>
                            <li>Painting (K) cannot begin until Masonry/Siding (H), Flooring (I), and Drywall (J) are completed.</li>
                            <li>The Final Inspection (L) cannot begin until the Painting (K) process has been completed.</li>
                        </ul>
                    </div>
                </div>
                
            </div>

            <div className={`Aon-Container ${PmModuleStyle['Aon-Container']} ${isOverlay ? PmModuleStyle['pmprework-overlay'] : ''}`}>
                
                <div className={`mbottom ${PmModuleStyle.introtext} ${PmModuleStyle['mbottom']} ${PmModuleStyle['AONWidth']}`}>
                    <h2 className={`${PmModuleStyle['intro-heading']}`}>AON</h2>
                    <p className={`${PmModuleStyle["indent-para"]}`}>Click on a node to see subcontractor choices.</p>
                    <div id="aon_container" style={{ "float": "left", "position": "relative" ,"overflow" : "auto","max-height":"213px","max-width":"585px","min-height":"200px","width":"100%","bottom":"8px"}}>
                        <svg id="aonSvg" aria-label="Activity-on-Node Diagram, with nodes from A to L label." width="650" height="200" xmlns="http://www.w3.org/2000/svg">
                            <defs id="aonDef">
                                <marker id="red_arrow" viewBox="0 0 10 10" refX="9" refY="3" markerUnits="userSpaceOnUse" markerWidth="10" markerHeight="100" orient="auto">
                                    <path d="M0,0 L0,6 L9,3 z" fill="red">
                                    </path>
                                </marker>
                                <marker id="grey_arrow" viewBox="0 0 10 10" refX="9" refY="3" markerUnits="userSpaceOnUse" markerWidth="10" markerHeight="100" orient="auto">
                                    <path d="M0,0 L0,6 L9,3 z" fill="grey">
                                    </path>
                                </marker>
                            </defs>
                        </svg>
                        <div className="ui prework-graph_info popup" id="graph_tooltip" style={{ "max-height": "100vh" }}></div>
                        <div className={`ui task-selector-bg modal`} id="divTaskSelector" style={{ "display": "none", "width": "400px" }} > {/* onClick={() => closeTaskSelectionPopup('close')} */}
                            <div className={`task-selector task_${selectedTask?.taskId}`} id="task-selector" role="dialog" >
                                <div className="decision-title">
                                    <h2 tabindex="-1" className="taskPopUpHeading">Task {selectedTask?.taskId}{`)`}  {selectedTask?.taskName}</h2>
                                    <div className="actions">
                                        <a href="javascript:void(0)" style={{ "float": "left", "position": "relative" }} title="close" role="button" id="closePopup" className="ui close-button" onClick={() => closeTaskSelectionPopup('close')}> </a>
                                    </div>
                                </div>

                                <div style={{ "margin-top": "27px", "margin-bottom": "10px" }}>
                                    {selectedTask?.taskOptionType != 'NA' && <span>Select Subcontractor</span>}
                                    <div className="actions" style={{float:"right"}}><button className="ui save_tasks" onClick={() => saveSubcontractor()} disabled={prework?.completed || (selOption.current == "")}>Save</button></div>
                                </div>
                                <div>
                                    <form className="sub_contractors">
                                        {
                                            selectedTask?.pmTaskOptions?.map((task, index) => (
                                                // <div className="actions">
                                                <a key={index} tabIndex={prework?.completed==0 ? 0 : -1} role="button" href="javascript:void(0);" task={JSON.stringify(task)} title={`${task?.companyName} Complete work in ${task?.days > 1 ? `${task?.days} days` : `${task?.days} day`}. Labor cost $${task.cost}.`} className={`ui radio taskDSecisionPopUpAnchorTag ${(!selectedTask.taskOptionAvailable || task.taskState == 'IN_PROGRESS') ? 'sub_contractor_disabled' : ''}`} onClick={() => {
                                                    if (!Object.keys(dependentTasks).includes(task?.taskId)) {
                                                        (!selectedTask?.taskOptionAvailable) && onHandleSelectTaskOption(task, task['table-index'])
                                                    }
                                                }
                                                } aria-selected={copyPrework?.attemptdata?.selectedOptions  ? (task?.optionType == copyPrework?.attemptdata?.selectedOptions[selectedTask?.taskId]) : false} aria-disabled={prework?.completed ? true : false} disabled={prework?.completed} style={{opacity:'1'}}>
                                                    {/* <div className={`clearfix person-item ${(copyPrework?.attemptdata?.selectedOptions ? (task?.optionType == copyPrework?.attemptdata?.selectedOptions[selectedTask?.taskId]) : (task?.optionType == taskOptiontype[selectedTask?.taskId]))  ? 'active_item' : ''}`} data-optionType={task?.optionType}> */}
                                                    <div className={`clearfix person-item ${(copyPrework?.attemptdata?.selectedOptions  && (task?.optionType == copyPrework?.attemptdata?.selectedOptions[selectedTask?.taskId]))  ? 'active_item' : ''}`} data-optionType={task?.optionType}>
                                                        <div style={{ "display": "flex" }}>
                                                            <div className="face"><img src={`${require(`../assets/prework-character-portraits/${task.taskId + index}.png`)}`} alt={`${task?.companyName}`} /></div>
                                                            <div className="person-description">
                                                                {/* <span className="screenHidden">{task?.companyName}</span> */}
                                                                <h3 aria-hidden="true">{task?.companyName}</h3>
                                                                <p>
                                                                    Complete work in {task?.days > 1 ? `${task?.days} days` : `${task?.days} day`}. Labor cost ${task.cost}.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a>
                                                // </div>
                                            ))
                                        }
                                    </form>
                                    {
                                        selectedTask?.pmTaskOptions?.length > 1 && (<form className={`work_overtime ${PmModuleStyle.work_overtime}`} style={{ "display": "none" }}>
                                            <fieldset>
                                                <legend className="select-title">
                                                    <span>Select Expedite options</span>
                                                </legend>
                                                {
                                                    selectedTask?.pmTaskOptions?.map((task, index) => (
                                                        task?.optionType == selectedTask?.selectedOptionType && (
                                                            <div key={index} style={{ "display": "flex" }}>
                                                                <input type="checkbox" disabled={!selectedTask?.overTimeOptionAvailable} checked={task?.overTimeSelected} name="overtime" onChange={() => { onHandleChange(task) }} onClick={() => { onHandleChange(task) }} id={`overtime_${index}`} />
                                                                <label htmlFor={`overtime_${index}`}>
                                                                    <span className="before sr-only" aria-hidden="true" role="presentation"></span>
                                                                    <div className="person-description">
                                                                        <h3>Choose Work Overtime</h3>
                                                                        <p>
                                                                            {/* Costs ${overtimeData?.cost} extra. Reduces task time by {overtimeData?.days > 1 ? `${overtimeData?.days} days` : `${overtimeData?.days} day`}. */}
                                                                            Costs
                                                                            ${selectedTask?.selectedOptionType == "CHEAPER"
                                                                                ? `${selectedTask?.cheaperOptionOverTimeCost} `
                                                                                : selectedTask?.selectedOptionType == "STANDARD"
                                                                                    ? `${selectedTask?.standardOptionOverTimeCost} `
                                                                                    : `${selectedTask?.expensiveOptionOverTimeCost} `}
                                                                            extra. Reduces task time by

                                                                            {/* {overtimeData?.days > 1 ? `${overtimeData?.days} days` : `${overtimeData?.days} day`}. */}
                                                                            {
                                                                                selectedTask?.selectedOptionType === "CHEAPER"
                                                                                    ? selectedTask?.cheaperOverTimeDays > 1
                                                                                        ? ` ${selectedTask?.cheaperOverTimeDays} days`
                                                                                        : ` ${selectedTask?.cheaperOverTimeDays} day`
                                                                                    : selectedTask?.selectedOptionType === "STANDARD"
                                                                                        ? selectedTask?.standardOverTimeDays > 1
                                                                                            ? ` ${selectedTask?.standardOverTimeDays} days`
                                                                                            : ` ${selectedTask?.standardOverTimeDays} day`
                                                                                        : selectedTask?.expensiveOverTimeDays > 1
                                                                                            ? ` ${selectedTask?.expensiveOverTimeDays} days`
                                                                                            : ` ${selectedTask?.expensiveOverTimeDays} day`
                                                                            }.
                                                                        </p>
                                                                    </div>
                                                                    <span className="after sr-only" aria-hidden="true" role="presentation"></span>
                                                                </label>
                                                            </div>)
                                                    ))
                                                }
                                                {
                                                    selectedTask?.pmTaskOptions?.map((task, index) => (
                                                        task?.optionType == selectedTask?.selectedOptionType && (
                                                            <div key={index} style={{ "display": "flex" }}>
                                                                <input type="checkbox" disabled={!selectedTask?.localSupplierOptionAvailable} checked={task?.localSupplierSelected} name="supplier" onChange={() => { onHandleChange(task) }} onClick={() => { onHandleChange(task) }} id={`localSupplier_${index}`} />
                                                                <label htmlFor={`localSupplier_${index}`}>
                                                                    <span className="before sr-only" aria-hidden="true" role="presentation"></span>
                                                                    <div className="person-description">
                                                                        {/* <h3>{supplierData?.suppilerName}</h3> */}
                                                                        <h3>{selectedTask?.localSuppilerOptionName}</h3>
                                                                        <p>
                                                                            {/* Costs ${supplierData?.cost} extra. Reduces task time by {supplierData?.days > 1 ? `${supplierData?.days} days` : `${supplierData?.days} day`}. */}
                                                                            Costs ${selectedTask?.localSupplierCost} extra. Reduces task time by {selectedTask?.localSupplierDays > 1 ? `${selectedTask?.localSupplierDays} days` : `${selectedTask?.localSupplierDays} day`}.
                                                                        </p>
                                                                    </div>
                                                                    <span className="after sr-only" aria-hidden="true" role="presentation"></span>
                                                                </label>
                                                            </div>
                                                        )
                                                    ))
                                                }
                                            </fieldset>
                                        </form>)
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>
                <div className={`${PmModuleStyle['input-Summary']}`}>
                <div>
                <div id="screen-reader-content" aria-live="assertive"></div>
                    <p>
                        <strong>Total Cost : $ <span className={`${PmModuleStyle['Calc-totalCost']}`}>
                        {
                            formatNum(calculateTotalCost()) + " "
                        }
                        {
                            (prework?.completed) ? (allCostsNonEmpty && calculateTotalCost() <= TargetTotalCost) 
                            ? <span className={`${PmModuleStyle["correct-sign"]}`}>
                                <span className="sr-only">correct total cost</span>
                            </span> 
                            : <span className={`${PmModuleStyle["incorrect-sign"]}`}>
                                <span className="sr-only">incorrect total cost</span>
                            </span>
                            : ''
                        }
                    </span></strong></p>
                    <p><strong>Project Duration: <span className={`${PmModuleStyle['Calc-totalDays']}`}>
                        {
                            totalDurations + " "
                        }
                        {
                            (prework?.completed) ? (alldurationsNonEmpty && totalDurations <= TargetTotalDays) 
                            ? <span className={`${PmModuleStyle["correct-sign"]}`}>
                                <span className="sr-only">correct project duration</span>
                            </span>
                            : <span className={`${PmModuleStyle["incorrect-sign"]}`}>
                                <span className="sr-only">incorrect project duration</span>
                            </span>
                            : ''
                        }
                    </span> (Days)</strong></p>
                    <p><strong>Project Critical Path:  <span className={`${PmModuleStyle['Critical-pathList']}`}>
                    {getCriticalTaskIds(ispreworkData).join(', ') + " "}
                    {
                        (prework?.completed) ? (allselectedPredecessorNonEmpty && allCostsNonEmpty && alldurationsNonEmpty && arraysAreEqual) 
                        ? <span className={`${PmModuleStyle["correct-sign"]}`}>
                                <span className="sr-only">correct project critical path</span>
                        </span>
                        : <span className={`${PmModuleStyle["incorrect-sign"]}`}>
                                <span className="sr-only">incorrect project critical path</span>
                        </span>
                        : ''
                    }
                </span></strong></p>
                </div>
                
                </div>

            </div>
          
            <div className={`${PmModuleStyle['prework-table-container']}`}>
            <table id="pmPreworkTable" className={`ui celled table stackable ${PmModuleStyle['prework-table']}`}>
                    <thead className={`${isOverlay ? PmModuleStyle['pmprework-overlay'] : ''}`}>
                        <tr>
                            <th scope="col">Activity</th>
                            <th scope="col">Predecessor(s)</th>
                            <th scope="col">Cost</th>
                            <th className={`fixed-last-th ${PmModuleStyle['fixed-last-th']}`} scope="col">Duration (Days)</th>
                            <th className={`fixed-last-th ${PmModuleStyle['fixed-last-th']}`} scope="col">Critical Path</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(ispreworkData)?.map((item, index) => (
                            <tr key={index}>
                               
                                <th scope="row">
                                    <a href="javascript:void(0)" className={`ui button ${PmModuleStyle['activity-circle']}`} role="button" onClick={onClickHandler}>
                                        {/* <div className={`${PmModuleStyle['taskId']}`}>{item.taskId}</div> */}
                                        <span>{item.taskId}{") "}{item.activity}</span>
                                    </a>
                                </th>
                                <td>
                                    {index === 0 ? '-' : (

                                        <div className={`${PmModuleStyle['searchbox']}`} data-id={`searchbox`}>
                                           <div className={`${PmModuleStyle['Selected-items']}`}>
                                           <button 
                                            data-task={item.taskId}
                                            aria-haspopup="listbox"
                                            onClick={() => handleToggle(index)}
                                            onKeyDown={(e) => handleKeyDownBtn(e, index)}
                                            aria-expanded={activeIndex === index ? true : false}
                                            tabIndex={0} // Allows button to be focusable for Enter key press
                                            disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")} style={{opacity:'1'}}
                                        >{item.selectedPredecessor.length > 0 ? (
                                            item.selectedPredecessor.map((value, index) => (
                                            <span key={index} className={`${PmModuleStyle['filter-item']}`}>
                                                <span className={`${PmModuleStyle['filter-item-text']}`}>{value}</span>
                                            </span>
                                            ))
                                        ) : 'Select'}</button>
                                        
                                        </div>
                                            {activeIndex === index && (
                                            <ul
                                                role="listbox"
                                                aria-multiselectable="true"
                                                tabIndex="0"
                                                ref={listRef}
                                                // onKeyDown={handleKeyDown}
                                                className={`${PmModuleStyle['OptionListBox']}`}
                                            >
                                                {item.prevTaskId.map((option, index) => (
                                                <li
                                                    key={option.key}
                                                    role="option"
                                                    aria-selected={item.selectedPredecessor.includes(option.previousTaskId)}
                                                    onClick={(e) => handleOptionClick(option.previousTaskId,item,e)}
                                                    onKeyDown={(e) => handleKeyDown(option.previousTaskId,item,e)}
                                                    onDoubleClick={(e)=> e.preventDefault()}
                                                    tabIndex={focusedIndex === index ? 0 : -1} // Manage focus using tabIndex
                                                    className={`${PmModuleStyle['OptionItem']} ${item.selectedPredecessor.includes(option.previousTaskId) ? `isSelected` : ``}`}>
                                                        <span className={`checkmark ${item.selectedPredecessor.includes(option.previousTaskId) ? `Optchecked` : `Optunchecked`}`} aria-hidden="true"></span>
                                                    {option.previousTaskId}
                                                </li>
                                                ))}
                                            </ul>
                                            )}
                                        </div>
                                    )}
                                </td>
                                <td>
                                    {/* <div className={`${PmModuleStyle['iconsInput']}`}>
                                        {(prework?.completed && (verificationCost[index] === true)) ? <span style={{ color: 'green', marginRight: '5px' }}>&#10004;</span> : ""}
                                        {(prework?.completed && (verificationCost[index] === false)) ? <span style={{ color: 'red', marginRight: '5px' }}>&#10008;</span> : ""}
                                        {<input
                                            type="text"
                                            aria-label="Cost"
                                            autoComplete="off"
                                            value={costInputs[index]}
                                            id={`${PmModuleStyle.qtyInput}`}
                                            disabled={(prework?.completed)} readOnly />}
                                    </div> */}
                                    <input type="text"
                                            aria-label={costInputs[index] === "" ? "Cost blank" : "Cost"}
                                            autoComplete="off"
                                            value={costInputs[index]}
                                            id={`${PmModuleStyle.qtyInput}`}
                                            disabled={(prework?.completed)} readOnly style={{display:'block'}}/>
                                </td>
                                <td>
                                    {/* <div className={`${PmModuleStyle['iconsInput']}`}>
                                    {(prework?.completed &&(verificationDays[index] === true)) ? <span style={{ color: 'green', marginRight: '5px' }}>&#10004;</span> : ""}
                                    {(prework?.completed && (verificationDays[index] === false)) ? <span style={{ color: 'red', marginRight: '5px' }}>&#10008;</span> : ""}
                                    {verificationDays[index] === true && <span style={{ color: 'green', marginRight: '5px' }}>&#10004;</span>}
                                    {verificationDays[index] === false && <span style={{ color: 'red', marginRight: '5px' }}>&#10008;</span>}
                                    {<input
                                        type="text"
                                        aria-label="Cost"
                                        autoComplete="off"
                                        value={dayInputs[index]}
                                        id={`${PmModuleStyle.qtyInput}`}
                                        disabled={prework?.completed} readOnly />}
                                        </div> */}
                                    <input
                                        type="text"
                                        aria-label={dayInputs[index] === "" ? "Duration (Days) blank" : "Duration (Days)"}
                                        autoComplete="off"
                                        value={dayInputs[index]}
                                        id={`${PmModuleStyle.qtyInput}`}
                                        disabled={prework?.completed} readOnly style={{display:'block'}}/>
                                </td>
                                        
                                <td>
                                <div className={`${PmModuleStyle['iconsInput']}`}>
                                    {(prework?.completed && (verificationCritical[index] === true)) 
                                    ? <span className={`${PmModuleStyle["correct-sign"]}`}>
                                        <span className="sr-only">correct critical path</span>
                                    </span> 
                                    : ""}
                                    {(prework?.completed && (verificationCritical[index] === false)) 
                                    ? <span className={`${PmModuleStyle["incorrect-sign"]}`}>
                                        <span className="sr-only">incorrect critical path</span>
                                    </span> 
                                    : ""}
                                    {<input type="checkbox" id={`checkbox-${index}`} aria-label="CriticalPath" autoComplete="off" checked={checkedStates[index]} onChange={(e) => checkBoxHandler(index, e)} onKeyDown={(e) => handleKeyDownCheckBox(index, e)} disabled={prework?.completed} 
                                    />}
                                </div>    
                                    </td>
                            </tr>
                        ))}
                    </tbody>
            </table>
            </div>
            {/* <div className={`mbottom ${PmModuleStyle.introtext} ${PmModuleStyle['mbottom']} ${PmModuleStyle['input-Summary']}`}>
                <div>
                    <p>
                        <strong>Total Cost : $ <span className={`${PmModuleStyle['Calc-totalCost']}`}>
                        {
                            formatNum(calculateTotalCost()) + " "
                        }
                        {
                            (prework?.completed) ? (allCostsNonEmpty && calculateTotalCost() <= TargetTotalCost) 
                            ? <span className={`${PmModuleStyle["correct-sign"]}`}></span> 
                            : <span className={`${PmModuleStyle["incorrect-sign"]}`}></span>
                            : ''
                        }
                    </span></strong></p>
                    <p><strong>Project Duration: <span className={`${PmModuleStyle['Calc-totalDays']}`}>
                        {
                            totalDurations + " "
                        }
                        {
                            (prework?.completed) ? (alldurationsNonEmpty && totalDurations <= TargetTotalDays) 
                            ? <span className={`${PmModuleStyle["correct-sign"]}`}></span>
                            : <span className={`${PmModuleStyle["incorrect-sign"]}`}></span>
                            : ''
                        }
                    </span> (Days)</strong></p>
                </div>
                <p><strong>Project Critical Path:  <span className={`${PmModuleStyle['Critical-pathList']}`}>
                    {getCriticalTaskIds(ispreworkData).join(', ') + " "}
                    {
                        (prework?.completed) ? (allselectedPredecessorNonEmpty && allCostsNonEmpty && alldurationsNonEmpty && arraysAreEqual) 
                        ? <span className={`${PmModuleStyle["correct-sign"]}`}></span>
                        : <span className={`${PmModuleStyle["incorrect-sign"]}`}></span>
                        : ''
                    }
                </span></strong></p>
            </div> */}
            
            <div className={`${PmModuleStyle['bottom-wrapper']}`}>
              
                <div className={`${PmModuleStyle["btn-container"]}`}>
                    <div className={`${PmModuleStyle["submitsaveContainer"]}`}>
            {
                !(prework?.completed) ?
                <Button 
                    btnClass={`title ui label`}   
                    clickEventHandler={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        if(e.target.textContent === 'Save'){
                            handleAttemptData();
                            isToActivateToaster.current = true;
                        }
                        return false;
                    }} 
                    customBtnStyle={{
                    zIndex: 1,
                    pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                    width: '90px',
                    cursor: 'pointer',
                    marginLeft: '20px'
                    }}
                    disabled={isRequestLoading || !(prework?.mode == "do" || prework?.mode == "preview")}
                    btnName={"Save"}
                />
                :""
            }
            {
                !(prework?.completed) ?
                <Button 
                    btnClass={`title ui label`}   
                    clickEventHandler={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        if(e.target.textContent === 'Submit'){
                            verifyInputs();
                        }
                        return false;
                    }} 
                    customBtnStyle={{
                    zIndex: 1,
                    pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                    width: '90px',
                    cursor: 'pointer',
                    marginLeft: '20px'
                    }}
                    disabled={isRequestLoading || !(prework?.mode == "do" || prework?.mode == "preview")}
                    btnName={"Submit"}
                />
                :""
            }
            </div>
            <div id="saveToaster" role="alert" className={`ui message ${PmModuleStyle['save-toaster']}`} style={{"display": "none"}}>
                <p>Your data is saved, to complete activity please click on Submit.</p>
            </div>
            {
                (prework?.completed && prework?.hasOwnProperty('score')) ?
                <div className={`${PmModuleStyle["score-container"]}`}>
                    <div className={`${PmModuleStyle["score-div"]}`} id="preworkScoreBlock">
                        {/* Score: {scorePercentage}% ({scored}/{OutofScore} points) */}
                        Score: {prework?.score}% ({prework?.score}/{100} points)
                    </div>
                    <div className={`${PmModuleStyle["completionbar"]}`}>Click 
                    <Button 
                            btnClass={`title ui label`}   
                            clickEventHandler={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if(e.target.textContent === 'Retry' && (prework?.completed != 0 && prework?.nextattempt == true)){
                                    retryPrework();
                                }
                                return false;
                            }} 
                            customBtnStyle={{
                                pointerEvents: 'auto',
                                zIndex: 1,
                                cursor: 'pointer',
                                marginLeft: '20px',
                                width: '75px',
                                opacity: 1,
                                margin: "3px 8px",
                                marginLeft : "8px"
                            }}
                            // btnParentStyle={{display:"inline-block"}}
                            btnParentStyle={{display:"block"}}
                            btnName={"Retry"}
                            disabled={!(prework?.mode == "do" || prework?.mode == "preview")}
                    />
                    to attempt again <strong>(remaining attempts: {prework?.remattempt})</strong>. Click 
                    <Button 
                    btnClass={`title ui label`}   
                    clickEventHandler={handlePopupExitSim} 
                    customBtnStyle={{
                        zIndex: 1,
                        cursor: 'pointer',
                        marginLeft: '20px',
                        width: '75px',
                        margin: "3px 8px",
                        marginLeft : "8px"
                    }}
                    // btnParentStyle={{display:"inline-block"}}
                    btnParentStyle={{display:"block"}}
                    btnName={"Close"}
                    />
                        to exit.</div>
                </div>
                : ""
            }
        </div>
            </div>
        </div>

    )
}
export default Prework;